import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import db from "./Firebase";
import {
  collection,
  doc,
  getDoc,
  updateDoc,
  query,
  getDocs,
  addDoc,
  orderBy,
} from "firebase/firestore";
import Moment from "moment";
import { Button, Form, Modal } from "react-bootstrap";
import * as XLSX from "xlsx";

const OrdersData = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleSteps, setVisibleSteps] = useState({});
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadData, setUploadData] = useState({
    orderId: "",
    phoneNo: "",
    itemName: "",
    itemIndex: null,
    processIndex: null,
    key: "",
    url: "",
  });
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [reasonText, setReasonText] = useState("");
  const [currentAction, setCurrentAction] = useState(null);
  const [logsMap, setLogsMap] = useState({});



  const [selectedState, setSelectedState] = useState("All");
const [selectedItemName, setSelectedItemName] = useState("All");
const [selectedFunder, setSelectedFunder] = useState("All");
const [selectedPhase, setSelectedPhase] = useState("All");

const [uniqueStates, setUniqueStates] = useState([]);
const [uniqueItemNames, setUniqueItemNames] = useState([]);
const [uniqueFunders, setUniqueFunders] = useState([]);


  useEffect(() => {
    fetchOrders();
  }, []);


  const fetchParlourData = async (phones) => {
  if (!phones.length) return {};

  const chunks = [];
  while (phones.length) chunks.push(phones.splice(0, 10));

  const parlourChunkPromises = chunks.map(async (chunk) => {
    const snap = await db
      .collection("parlour_name")
      .where("phone", "in", chunk)
      .get();

    return snap.docs.map((doc) => {
      const d = doc.data() || {};
      return {
        phone: d.phone,
        city: d.city || "-",
        state: d.state || "-",
        business_type: d.business_type || "-",
      };
    });
  });

  const results = await Promise.all(parlourChunkPromises);
  const flat = results.flat();
  return flat.reduce((acc, p) => {
    acc[normalizePhone(p.phone)] = { city: p.city, state : p.state, business_type: p.business_type };
    return acc;
  }, {});
};

const normalizePhone = (phone) => String(phone || "").replace(/\D/g, "").slice(-10);

const normalizePhase = (phase) => {
  const value = String(phase || "").trim();
  const match = value.match(/\d+/);
  return match ? match[0] : value;
};

const fetchFunderUsersData = async () => {
  const snap = await getDocs(collection(db, "funder_users_list"));
  const usersMap = {};

  snap.forEach((docSnap) => {
    const d = docSnap.data() || {};
    const phone = normalizePhone(d.phone_no || docSnap.id);
    if (!phone) return;

    usersMap[phone] = {
      funder: d.funder || "-",
      phase: normalizePhase(d.phase) || "-",
    };
  });

  return usersMap;
};


  // const fetchOrders = async () => {
  //   try {
  //     const ordersRef = collection(db, "nv_orders_data");
  //     const q = query(ordersRef, orderBy("order_date", "desc"));
  //     const querySnapshot = await getDocs(q);
  //     const data = [];
  //     querySnapshot.forEach((docSnap) => {
  //       data.push({ id: docSnap.id, ...docSnap.data() });
  //     });
  //     setOrders(data);
  //     setFilteredOrders(data);

  //     // seed logsMap from existing fetched data
  //     const newLogsMap = {};
  //     data.forEach((order) => {
  //       (order.items || []).forEach((item, idx) => {
  //         const key = `${order.id}-${idx}`;
  //         if (item.logs && Array.isArray(item.logs)) {
  //           newLogsMap[key] = item.logs.map((l) => ({
  //             timestamp: l.timestamp,
  //             action: l.action,
  //             reason: l.reason,
  //           }));
  //         }
  //       });
  //     });
  //     setLogsMap(newLogsMap);

  //   } catch (err) {
  //     console.error("Error fetching orders:", err);
  //   }
  // };


  const fetchOrders = async () => {
  try {
    const ordersRef = collection(db, "nv_orders_data");
    const q = query(ordersRef, orderBy("order_date", "desc"));
    const querySnapshot = await getDocs(q);

    const data = [];
    const phones = [];

    querySnapshot.forEach((docSnap) => {
      const d = { id: docSnap.id, ...docSnap.data() };
      data.push(d);
      if (d.phone_no) phones.push(d.phone_no);
    });

    const uniquePhones = [...new Set(phones.map(normalizePhone).filter(Boolean))];
    const [parlourMap, funderUsersMap] = await Promise.all([
      fetchParlourData([...uniquePhones]),
      fetchFunderUsersData(),
    ]);

    // merge
    const merged = data.map((o) => ({
      ...o,
      parlour: parlourMap[normalizePhone(o.phone_no)] || { city: "-", business_type: "-", state: "-" },
      userType: funderUsersMap[normalizePhone(o.phone_no)] || { funder: "Other Categories", phase: "-" },
    }));

    setOrders(merged);
    setFilteredOrders(merged);

    // ✅ Unique States
const states = Array.from(
  new Set(
    merged
      .map((o) => o?.parlour?.state)
      .filter((s) => s && s !== "-" && String(s).trim() !== "")
  )
).sort((a, b) => String(a).localeCompare(String(b)));

setUniqueStates(states);

// ✅ Unique Item Names (from items array)
const itemNames = Array.from(
  new Set(
    merged
      .flatMap((o) => (o.items || []).map((it) => it?.name))
      .filter((n) => n && String(n).trim() !== "")
  )
).sort((a, b) => String(a).localeCompare(String(b)));

setUniqueItemNames(itemNames);

const funders = Array.from(
  new Set(
    merged
      .map((o) => o?.userType?.funder)
      .filter((f) => f && String(f).trim() !== "")
  )
).sort((a, b) => String(a).localeCompare(String(b)));

setUniqueFunders(funders);

    // seed logsMap
    const newLogsMap = {};
    merged.forEach((order) => {
      (order.items || []).forEach((item, idx) => {
        const key = `${order.id}-${idx}`;
        if (item.logs && Array.isArray(item.logs)) {
          newLogsMap[key] = item.logs.map((l) => ({
            timestamp: l.timestamp,
            action: l.action,
            reason: l.reason,
          }));
        }
      });
    });
    setLogsMap(newLogsMap);

  } catch (err) {
    console.error("Error fetching orders:", err);
  }
};



  // const handleSearch = (e) => {
  //   const q = e.target.value;
  //   setSearchQuery(q);
  //   if (q.trim() === "") {
  //     setFilteredOrders(orders);
  //   } else {
  //     setFilteredOrders(
  //       orders.filter((o) => (o.phone_no || "").includes(q.trim()))
  //     );
  //   }
  // };


  const handleSearch = (e) => {
  const q = e.target.value;
  setSearchQuery(q);
  applyFilters(orders, q, selectedState, selectedItemName, selectedFunder, selectedPhase);
};


const handleStateFilter = (value) => {
  setSelectedState(value);
  applyFilters(orders, searchQuery, value, selectedItemName, selectedFunder, selectedPhase);
};

const handleItemNameFilter = (value) => {
  setSelectedItemName(value);
  applyFilters(orders, searchQuery, selectedState, value, selectedFunder, selectedPhase);
};

const handleFunderFilter = (value) => {
  setSelectedFunder(value);
  setSelectedPhase("All");
  applyFilters(orders, searchQuery, selectedState, selectedItemName, value, "All");
};

const handlePhaseFilter = (value) => {
  setSelectedPhase(value);
  applyFilters(orders, searchQuery, selectedState, selectedItemName, selectedFunder, value);
};


useEffect(() => {
  applyFilters(orders, searchQuery, selectedState, selectedItemName, selectedFunder, selectedPhase);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [orders]);

  const applyFilters = (baseOrders, phoneQ, stateQ, itemQ, funderQ, phaseQ) => {
  const phone = (phoneQ || "").trim();

  // Keep order structure, but filter items per order if needed
  const result = (baseOrders || [])
    .filter((o) => {
      const phoneOk = phone === "" ? true : String(o.phone_no || "").includes(phone);
      const stateOk =
        stateQ === "All" ? true : String(o?.parlour?.state || "") === String(stateQ);
      const funderOk =
        funderQ === "All" ? true : String(o?.userType?.funder || "") === String(funderQ);
      const phaseOk =
        phaseQ === "All" ? true : String(o?.userType?.phase || "") === String(phaseQ);
      return phoneOk && stateOk && funderOk && phaseOk;
    })
    .map((o) => {
      if (itemQ === "All") return o;

      const items = (o.items || []).filter((it) => String(it?.name || "") === String(itemQ));
      return { ...o, items };
    })
    // remove orders where items become empty after item filter
    .filter((o) => (o.items || []).length > 0);

  setFilteredOrders(result);
};

const phaseOptions = Array.from(
  new Set(
    (orders || [])
      .filter((o) =>
        selectedFunder === "All"
          ? true
          : String(o?.userType?.funder || "") === String(selectedFunder)
      )
      .map((o) => o?.userType?.phase)
      .filter((p) => p && p !== "-" && String(p).trim() !== "")
      .map((p) => String(p))
  )
).sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }));

  const toggleSteps = (orderId, itemIndex) => {
    const key = `${orderId}-${itemIndex}`;
    setVisibleSteps((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const addLogAndPersist = async (orderId, itemIndex, action, reason = null) => {
    const key = `${orderId}-${itemIndex}`;
    const logEntry = { timestamp: new Date(), action, reason };
    // Update UI state
    setLogsMap((prev) => {
      const arr = prev[key] || [];
      return { ...prev, [key]: [...arr, logEntry] };
    });
    // Persist to Firestore
    const ref = doc(db, "nv_orders_data", orderId);
    const snap = await getDoc(ref);
    if (!snap.exists()) return;
    const order = snap.data();
    const items = Array.isArray(order.items) ? [...order.items] : [];
    if (!items[itemIndex]) {
      console.warn("Invalid itemIndex when adding logs:", orderId, itemIndex);
    } else {
      const item = { ...items[itemIndex] };
      const existingLogs = Array.isArray(item.logs) ? [...item.logs] : [];
      item.logs = [...existingLogs, logEntry];
      items[itemIndex] = item;
      await updateDoc(ref, { items });
    }
  };


  const toJsDate = (ts) => {
  if (!ts) return null;
  if (typeof ts.toDate === "function") return ts.toDate(); // Firestore Timestamp
  if (ts instanceof Date) return ts;                       // JS Date
  if (typeof ts === "number") return new Date(ts);         // epoch ms
  if (typeof ts === "string") {
    const d = new Date(ts);
    return isNaN(d) ? null : d;                            // ISO/string
  }
  return null;
};



  const updateStepStatus = async (
    orderId,
    itemIndex,
    processIndex,
    newStatus,
    url,
  ) => {
    const ref = doc(db, "nv_orders_data", orderId);
    const snap = await getDoc(ref);
    if (!snap.exists()) return;
    const order = snap.data();
    const items = Array.isArray(order.items) ? [...order.items] : [];
    if (!items[itemIndex] || !Array.isArray(items[itemIndex].process)) {
      console.warn("Invalid indices for updateStepStatus", orderId, itemIndex, processIndex);
      return;
    }
    const item = { ...items[itemIndex] };
    item.process = [...item.process];
    item.process[processIndex] = {
      ...item.process[processIndex],
      status: newStatus,
      isActive: newStatus === "completed",
    };
    items[itemIndex] = item;
      // 🔄 Build update object

      const updateObj = { items };

    if (url && url.trim() !== "") {
      updateObj.url = url; // ✅ store at TOP LEVEL only when final URL is added
    }

    await updateDoc(ref, updateObj);
    // await updateDoc(ref, { items });

      
      
    // update local state
    setOrders((prev) =>
      prev.map((o) => (o.id === orderId ? { ...o, items } : o))
    );
    setFilteredOrders((prev) =>
      prev.map((o) => (o.id === orderId ? { ...o, items } : o))
    );
  };

  // const handleCallChange = async (
  //   fullname,
  //   phone,
  //   orderId,
  //   itemIndex,
  //   processIndex,
  //   key,
  //   value
  // ) => {
  //   await addLogAndPersist(orderId, itemIndex, `Youvati Call: '${value}'`);
  //   if (value === "Call Connected - Successfully connected with user. Requirement discussed and noted.") {
  //     await updateStepStatus(orderId, itemIndex, processIndex, "completed");
  //   } else {
  //     await updateStepStatus(orderId, itemIndex, processIndex, "failed");
  //   }
  // };


  const handleCallChange = async (
  fullname,
  phone,
  orderId,
  itemIndex,
  processIndex,
  key,
  value
) => {
  
  // CASE 1 — CLOSED
  if (value === "closed") {
    studioclosed(phone, fullname)
    await addLogAndPersist(orderId, itemIndex, "Youvati Call: 'closed'");
    await updateStepStatus(orderId, itemIndex, processIndex, "closed");
    return;
  }

  // Normal log
  await addLogAndPersist(orderId, itemIndex, `Youvati Call: '${value}'`);

  // CASE 2 — CONNECTED
  if (
    value ===
    "Call Connected - Successfully connected with user. Requirement discussed and noted."
  ) {
    await updateStepStatus(orderId, itemIndex, processIndex, "completed");
    
    return;
  }

  // CASE 3 — ALL OTHER VALUES
  await updateStepStatus(orderId, itemIndex, processIndex, "failed");
console.log(fullname);
console.log(phone);
console.log(value)

if(value === "Call Not Connected 1 - Tried calling user — call not connected. Will try again."){
  studiocallstatus(phone, fullname)
}
if(value === "Call Not Connected 2 - Second attempt made — still not connected. One more attempt remaining."){
  studiocallstatus(phone, fullname)
}
if(value === "closed"){
  studioclosed(phone, fullname)
}
if(value === "Call Connected - Successfully connected with user. Requirement discussed and noted."){
  console.log("Call Connected")
}

};

  const handleReasonSubmit = async () => {
    if (!currentAction) return;
    const { orderId, itemIndex, processIndex } = currentAction;
    await addLogAndPersist(orderId, itemIndex, `Youvati Call: reason for not connected '${reasonText}'`, reasonText);
    await updateStepStatus(orderId, itemIndex, processIndex, "failed");
    setShowReasonModal(false);
    setReasonText("");
    setCurrentAction(null);
  };

  const handleDesignComplete = async (
    fullname,
    phone,
    orderId,
    itemIndex,
    processIndex,
    key
  ) => {
    const result = await Swal.fire({
      title: "Design Ready",
      text: "Are you sure you want to mark Design as done?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, mark done",
    });
    if (result.isConfirmed) {
      await addLogAndPersist(orderId, itemIndex, `Design work has been completed by the team. Ready for review or delivery.`);
      await updateStepStatus(orderId, itemIndex, processIndex, "completed");
      studiodesignready(phone, fullname)
    }
  };

  const openUploadFileModal = (
    full_name,
    orderId,
    phoneNo,
    itemName,
    itemIndex,
    processIndex,
    key
  ) => {
    setUploadData({
      full_name,
      orderId,
      phoneNo,
      itemName,
      itemIndex,
      processIndex,
      key,
      url: "",
    });
    setShowUploadModal(true);
  };

  const handleUploadSubmit = async () => {
    const { full_name, orderId, phoneNo, itemName, url, itemIndex, processIndex } = uploadData;
    if (!url.trim()) {
      alert("Please enter a valid URL");
      return;
    }
    try {
      await addDoc(collection(db, "nv_downloads"), {
        category: "Design",
        date: new Date(),
        phone_no: phoneNo,
        title: itemName,
        url,
        orderId : orderId,
      });
      await updateStepStatus(orderId, itemIndex, processIndex, "completed", url);
      await addLogAndPersist(orderId, itemIndex, `Delivery - Final approved design shared with the user. Process closed.`);
      studiodesigndelivered(phoneNo, full_name)
      setShowUploadModal(false);
    } catch (err) {
      console.error(err);
      alert("Error uploading file");
    }
  };


const studioPurchased = async (phone, name) => {
  try {
    const raw = JSON.stringify({
      messaging_product: "whatsapp",
      to: `91${phone}`,              // ensure this is a valid WhatsApp user
      type: "template",
      template: {
        name: "studio_purchased",        // ensure this template exists & is approved
        language: { code: "en_US", policy: "deterministic" },
        components: [
          {
            type: "body",
            parameters: [
              { type: "text", text: `${name}` }
            ]
          }
        ]
      }
    });

    const response = await fetch(
      "https://graph.facebook.com/v14.0/104489945783566/messages",
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR",
          "Content-Type": "application/json"
        },
        body: raw
      }
    );

    const data = await response.json();
    console.log("WhatsApp API response:", data);

    if (!response.ok) {
      // The API returned an error
      alert("Failed to send template: " + (data.error?.message || JSON.stringify(data)));
    } else {
      alert("Template message sent successfully!");
    }

  } catch (err) {
    console.error("Unexpected error sending template:", err);
    alert("Unexpected error. Check console.");
  }
};

const studiocallstatus = async (phone, name) => {
  try {
    const raw = JSON.stringify({
      messaging_product: "whatsapp",
      to: `91${phone}`,              // ensure this is a valid WhatsApp user
      type: "template",
      template: {
        name: "studio_call_status",        // ensure this template exists & is approved
        language: { code: "en", policy: "deterministic" },
        components: [
          {
            type: "body",
            parameters: [
              { type: "text", text: `${name}` }
            ]
          }
        ]
      }
    });

    const response = await fetch(
      "https://graph.facebook.com/v14.0/104489945783566/messages",
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR",
          "Content-Type": "application/json"
        },
        body: raw
      }
    );

    const data = await response.json();
    console.log("WhatsApp API response:", data);

    if (!response.ok) {
      // The API returned an error
      alert("Failed to send template: " + (data.error?.message || JSON.stringify(data)));
    } else {
      alert("Template message sent successfully!");
    }

  } catch (err) {
    console.error("Unexpected error sending template:", err);
    alert("Unexpected error. Check console.");
  }
};

const studioclosed = async (phone, name) => {
  console.log("calling closeddddddd....")
  try {
    const raw = JSON.stringify({
      messaging_product: "whatsapp",
      to: `91${phone}`,              // ensure this is a valid WhatsApp user
      type: "template",
      template: {
        name: "studio_closed",        // ensure this template exists & is approved
        language: { code: "en", policy: "deterministic" },
        components: [
          {
            type: "body",
            parameters: [
              { type: "text", text: `${name}` }
            ]
          }
        ]
      }
    });

    const response = await fetch(
      "https://graph.facebook.com/v14.0/104489945783566/messages",
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR",
          "Content-Type": "application/json"
        },
        body: raw
      }
    );

    const data = await response.json();
    console.log("WhatsApp API response:", data);

    if (!response.ok) {
      // The API returned an error
      // alert("Failed to send template: " + (data.error?.message || JSON.stringify(data)));
    } else {
      // alert("Template message sent successfully!");
    }

  } catch (err) {
    console.error("Unexpected error sending template:", err);
    alert("Unexpected error. Check console.");
  }
};


const studiodesignready = async (phone, name) => {
  try {
    const raw = JSON.stringify({
      messaging_product: "whatsapp",
      to: `91${phone}`,              // ensure this is a valid WhatsApp user
      type: "template",
      template: {
        name: "studio_design_ready",        // ensure this template exists & is approved
        language: { code: "en", policy: "deterministic" },
        components: [
          {
            type: "body",
            parameters: [
              { type: "text", text: `${name}` }
            ]
          }
        ]
      }
    });

    const response = await fetch(
      "https://graph.facebook.com/v14.0/104489945783566/messages",
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR",
          "Content-Type": "application/json"
        },
        body: raw
      }
    );

    const data = await response.json();
    console.log("WhatsApp API response:", data);

    if (!response.ok) {
      // The API returned an error
      alert("Failed to send template: " + (data.error?.message || JSON.stringify(data)));
    } else {
      alert("Template message sent successfully!");
    }

  } catch (err) {
    console.error("Unexpected error sending template:", err);
    alert("Unexpected error. Check console.");
  }
};


const studiodesigndelivered = async (phone, name) => {
  try {
    const raw = JSON.stringify({
      messaging_product: "whatsapp",
      to: `91${phone}`,              // ensure this is a valid WhatsApp user
      type: "template",
      template: {
        name: "studio_design_delivered",        // ensure this template exists & is approved
        language: { code: "en", policy: "deterministic" },
        components: [
          {
            type: "body",
            parameters: [
              { type: "text", text: `${name}` }
            ]
          }
        ]
      }
    });

    const response = await fetch(
      "https://graph.facebook.com/v14.0/104489945783566/messages",
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR",
          "Content-Type": "application/json"
        },
        body: raw
      }
    );

    const data = await response.json();
    console.log("WhatsApp API response:", data);

    if (!response.ok) {
      // The API returned an error
      alert("Failed to send template: " + (data.error?.message || JSON.stringify(data)));
    } else {
      alert("Template message sent successfully!");
    }

  } catch (err) {
    console.error("Unexpected error sending template:", err);
    alert("Unexpected error. Check console.");
  }
};


const exportToExcel = (data) => {
  const rows = [];

  data.forEach((order) => {
    (order.items || []).forEach((item) => {
      rows.push({
        orderId: order.id,
        fullName: order.full_name,
        phoneNo: order.phone_no,
        city: order.parlour?.city || "-",
        state: order.parlour?.state || "-",
        businessType: order.parlour?.business_type || "-",
        funder: order.userType?.funder || "-",
        phase: order.userType?.phase || "-",
        itemName: item.name,
        itemPrice: item.membership_price,
        orderDate: order.order_date
          ? Moment(order.order_date.toDate()).format("YYYY-MM-DD HH:mm")
          : "",
      });
    });
  });

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `orders_export_${Date.now()}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
};


  return (
    <>
    {/* <button onClick={studioPurchased}>Click</button> */}
      <div className="p-2 d-flex justify-content-between">
        <Link to="/">
          <img src="/images/menubutton.png" alt="Menu" style={{ height: "2rem" }} />
        </Link>
        <Button
          variant="success"
          className="mb-3"
          onClick={() => exportToExcel(filteredOrders)}
        >
          Download Excel
        </Button>

      </div>
      <div className="p-3">
        {/* <div className="card-header pb-0 px-3 d-flex align-items-center gap-3">
          <h4>Orders List</h4>
          <Form.Control
            type="text"
            placeholder="Search by Phone Number..."
            value={searchQuery}
            onChange={handleSearch}
            style={{ width: "300px" }}
          />
        </div> */}

        <div className="card-header pb-0 px-3 d-flex align-items-center gap-3 flex-wrap">
  <h4 className="mb-0">Orders List</h4>

  <Form.Control
    type="text"
    placeholder="Search by Phone Number..."
    value={searchQuery}
    onChange={handleSearch}
    style={{ width: "260px" }}
  />

  {/* ✅ State Filter */}
  <Form.Select
    value={selectedState}
    onChange={(e) => handleStateFilter(e.target.value)}
    style={{ width: "220px" }}
  >
    <option value="All">All States</option>
    {uniqueStates.map((st) => (
      <option key={st} value={st}>
        {st}
      </option>
    ))}
  </Form.Select>

  {/* ✅ Item Name Filter */}
  <Form.Select
    value={selectedItemName}
    onChange={(e) => handleItemNameFilter(e.target.value)}
    style={{ width: "260px" }}
  >
    <option value="All">All Item Names</option>
    {uniqueItemNames.map((nm) => (
      <option key={nm} value={nm}>
        {nm}
      </option>
    ))}
  </Form.Select>

  <Form.Select
    value={selectedFunder}
    onChange={(e) => handleFunderFilter(e.target.value)}
    style={{ width: "220px" }}
  >
    <option value="All">All Funders</option>
    {uniqueFunders.map((funder) => (
      <option key={funder} value={funder}>
        {funder}
      </option>
    ))}
  </Form.Select>

  <Form.Select
    value={selectedPhase}
    onChange={(e) => handlePhaseFilter(e.target.value)}
    style={{ width: "180px" }}
  >
    <option value="All">All Phases</option>
    {phaseOptions.map((phase) => (
      <option key={phase} value={phase}>
        Phase {phase}
      </option>
    ))}
  </Form.Select>
</div>

        <div className="table-responsive fix-width scroll-inner mt-3">
          <table className="table table-bordered table-hover">
            <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
              <tr>
                <th>Order ID</th>
                <th>Full Name</th>
                <th>City</th>
                <th>State</th>
                <th>Business Type</th>
                <th>Funder</th>
                <th>Phase</th>
                {/* <th>Business Name</th> */}
                <th>Item Name</th>
                <th>Item Price</th>
                <th>Order Date</th>
                <th>Process Steps</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map((order) =>
                (order.items || []).map((item, itemIndex) => {
                  const key = `${order.id}-${itemIndex}`;
                  const logs = logsMap[key] || [];
                  const callStep = item.process.find((p) => p.step === "Youvati Call");
                  const designStep = item.process.find((p) => p.step === "Design");
                  const deliveryStep = item.process.find((p) => p.step === "Delivery");

                  return (
                    <React.Fragment key={key}>
                      <tr style={{ background: order.status === "Completed" ? "palegreen" : "" }}>
                        <td>
                          {order.id}
                          <br />
                          Total Amount: {order.final_total || "N/A"}
                        </td>
                        <td>
                          {order.full_name}
                          <br />
                          {order.phone_no}
                        </td>
                        <td>{order.parlour?.city || "-"}</td>
                        <td>{order.parlour?.state || "-"}</td>
                        <td>{order.parlour?.business_type || "-"}</td>
                        <td>{order.userType?.funder || "-"}</td>
                        <td>{order.userType?.phase ? `Phase ${order.userType.phase}` : "-"}</td>
                        {/* <td>{order.business_name}</td> */}
                        <td>{item.name}</td>
                        <td>{item.membership_price}</td>
                        <td>
                          {order.order_date
                            ? Moment(order.order_date.toDate()).format("YYYY-MM-DD HH:mm")
                            : "N/A"}
                        </td>
                        {/* <td>
                          <Button size="sm" variant="info" onClick={() => toggleSteps(order.id, itemIndex)}>
                            {visibleSteps[key] ? "Hide Steps" : "View Steps"}
                          </Button>
                        </td> */}
<td>
  <span class="btn-info btn-sm" style={{cursor :"pointer"}} size="sm" variant="info" onClick={() => toggleSteps(order.id, itemIndex)}>
    {visibleSteps[key] ? "Hide Steps" : "View Steps"}
  </span>

  {/* --- Show actual status phase --- */}
  <div style={{ marginTop: "26px", fontSize: "0.85rem", fontWeight: "500" }}>
    {(() => {
      const callStatus = item.process.find(p => p.step === "Youvati Call")?.status;
      const designStatus = item.process.find(p => p.step === "Design")?.status;
      const deliveryStatus = item.process.find(p => p.step === "Delivery")?.status;

     if (deliveryStatus === "completed") return "✅ Delivered";
if (designStatus === "completed") return "🎨 Designing Phase Completed → Delivery Phase";
if (callStatus === "completed") return "📞 Calling Phase Completed → Designing Phase";
if (callStatus === "closed") return "❌ Call Closed By Team";
if (callStatus === "failed") return "❌ Call Not Connected";
return "🕐 Calling Phase (Pending)";
    })()}
  </div>
</td>

                      </tr>

                      {visibleSteps[key] && (
                        <tr>
                          <td colSpan="11" style={{ background: "#fafafa" }}>
                            {(item.process || []).map((step, processIndex) => (
                              <div key={`${key}-${processIndex}`} className="d-flex align-items-center justify-content-between mb‑2">
                                <strong>{step.step}:</strong>
                                <div>
                                     {/* <h1>{step.status}</h1> */}
                                  {step.step === "Youvati Call" && (
                                    // <Form.Select
                                    //   size="sm"
                                    //   disabled={step.status === "completed" || step.status === "closed"}
                                    //   // defaultValue="pending"
                                    //   value={step.status}
                                    //   onChange={(e) =>
                                    //     handleCallChange(
                                    //       order.full_name,
                                    //       order.phone_no,
                                    //       order.id,
                                    //       itemIndex,
                                    //       processIndex,
                                    //       key,
                                    //       e.target.value
                                    //     )
                                    //   }
                                    // >
                                    //   <option >{step.status === "completed" ? "Completed" : "Pending"}</option>
                                    //   <option value="Call Not Connected 1 - Tried calling user — call not connected. Will try again.">Call Not Connected 1</option>
                                    //   <option value="Call Not Connected 2 - Second attempt made — still not connected. One more attempt remaining.">Call Not Connected 2</option>
                                    //   <option value="closed">Closed</option>
                                    //   <option value="Call Connected - Successfully connected with user. Requirement discussed and noted.">Call Connected</option>
                                    // </Form.Select>

                                    // {step.status === "completed"  ? <></> : <></>}
                                 

                                    <Form.Select
                                      size="sm"
                                      disabled={step.status === "completed" || step.status === "closed"}
                                      value={step.status}          // <-- MUST BE HERE
                                      onChange={(e) =>
                                        handleCallChange(
                                          order.full_name,
                                          order.phone_no,
                                          order.id,
                                          itemIndex,
                                          processIndex,
                                          key,
                                          e.target.value
                                        )
                                      }
                                    >

                                      {step.status === "completed" ? 
                                      <>
                                       <option value="Completed">Completed</option>
                                     
                                      </> : <>
                                       <option value="pending">Pending</option>
                                      <option value="Call Not Connected 1 - Tried calling user — call not connected. Will try again.">
                                        Call Not Connected 1
                                      </option>
                                      <option value="Call Not Connected 2 - Second attempt made — still not connected. One more attempt remaining.">
                                        Call Not Connected 2
                                      </option>
                                      <option value="closed">Closed</option>
                                      <option value="Call Connected - Successfully connected with user. Requirement discussed and noted.">
                                        Call Connected
                                      </option>
                                      </>}
                                     
                                    </Form.Select>

                                  )}

                                  {step.step === "Design" && callStep?.status === "completed" && (
                                    <div style={{ marginTop: "32px", }}>
                                    <span
                                    class="btn-info btn-sm"
                                      size="sm"
                                      variant="primary"
                                      style={{ cursor :"pointer" }}
                                      disabled={step.status === "completed"}
                                      onClick={() =>
                                        handleDesignComplete(
                                          order.full_name,
                                          order.phone_no,
                                          order.id,
                                          itemIndex,
                                          processIndex,
                                          key
                                        )
                                      }
                                    >
                                      {step.status === "completed" ? "Completed" : "Mark Design Completed"}
                                    </span>
                                    </div>
                                  )}

                                  {step.step === "Delivery" && designStep?.status === "completed" && (
                                     <div style={{ marginTop: "32px", }}>
                                    <span
                                    class="btn-info btn-sm"
                                      size="sm"
                                      variant="secondary"
                                      style={{cursor :"pointer" }}
                                      disabled={step.status === "completed"}
                                      onClick={() =>
                                        openUploadFileModal(
                                           order.full_name,
                                          order.id,
                                          order.phone_no,
                                          item.name,
                                          itemIndex,
                                          processIndex,
                                          key
                                        )
                                      }
                                    >
                                      {step.status === "completed" ? "Uploaded" : "Upload File"}
                                    </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}

                            <div style={{ marginTop: "1rem", padding: "0.5rem", background: "#fffef0" }}>
                              <strong>Logs:</strong>
                              {/* <ul>
                                {logs.map((log, idx) => (
                                  <li key={idx}>
                                    {Moment(log.timestamp).format("YYYY‑MM‑DD HH:mm:ss")} — {log.action}
                                    {log.reason ? ` (Reason: ${log.reason})` : ""}
                                  </li>
                                ))}
                              </ul> */}
                              <ul>
  {logs.map((log, idx) => {
    const d = toJsDate(log.timestamp);
    const when = d && Moment(d).isValid()
      ? Moment(d).format("YYYY-MM-DD HH:mm:ss")
      : ""; // or "—"
    return (
      <li key={idx}>
        {when} — {log.action}
        {log.reason ? ` (Reason: ${log.reason})` : ""}
      </li>
    );
  })}
</ul>

                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload File URL</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb‑3">
            <Form.Label>File URL</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter file URL"
              value={uploadData.url}
              onChange={(e) => setUploadData({ ...uploadData, url: e.target.value })}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUploadModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUploadSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrdersData;



// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import db from "./Firebase";
// import {
//   collection,
//   doc,
//   getDoc,
//   updateDoc,
//   query,
//   getDocs,
//   addDoc,
//   orderBy,
// } from "firebase/firestore";
// import Moment from "moment";
// import { Button, Form, Modal } from "react-bootstrap";
// import * as XLSX from "xlsx";

// const OrdersData = () => {
//   const [orders, setOrders] = useState([]);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleSteps, setVisibleSteps] = useState({});
//   const [showUploadModal, setShowUploadModal] = useState(false);
//   const [uploadData, setUploadData] = useState({
//     orderId: "",
//     phoneNo: "",
//     itemName: "",
//     itemIndex: null,
//     processIndex: null,
//     key: "",
//     url: "",
//   });
//   const [showReasonModal, setShowReasonModal] = useState(false);
//   const [reasonText, setReasonText] = useState("");
//   const [currentAction, setCurrentAction] = useState(null);
//   const [logsMap, setLogsMap] = useState({});

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = async () => {
//     try {
//       const ordersRef = collection(db, "nv_orders_data");
//       const q = query(ordersRef, orderBy("order_date", "desc"));
//       const querySnapshot = await getDocs(q);
//       const data = [];
//       querySnapshot.forEach((docSnap) => {
//         data.push({ id: docSnap.id, ...docSnap.data() });
//       });
//       setOrders(data);
//       setFilteredOrders(data);
//     } catch (err) {
//       console.error("Error fetching orders:", err);
//     }
//   };

//   const handleSearch = (e) => {
//     const q = e.target.value;
//     setSearchQuery(q);
//     if (q.trim() === "") {
//       setFilteredOrders(orders);
//     } else {
//       setFilteredOrders(orders.filter((o) => o.phone_no?.includes(q.trim())));
//     }
//   };

//   const toggleSteps = (orderId, itemIndex) => {
//     const key = `${orderId}-${itemIndex}`;
//     setVisibleSteps((prev) => ({ ...prev, [key]: !prev[key] }));
//   };

//   const addLog = (key, action, reason = null) => {
//     const timestamp = new Date();
//     setLogsMap((prev) => {
//       const arr = prev[key] || [];
//       return {
//         ...prev,
//         [key]: [...arr, { timestamp, action, reason }],
//       };
//     });
//   };

//   const updateStepStatus = async (orderId, itemIndex, processIndex, newStatus) => {
//     const ref = doc(db, "nv_orders_data", orderId);
//     const snap = await getDoc(ref);
//     if (!snap.exists()) return;
//     const order = snap.data();
//     if (
//       !order.items ||
//       !order.items[itemIndex] ||
//       !order.items[itemIndex].process
//     ) {
//       console.warn("Invalid indices for updateStepStatus", orderId, itemIndex, processIndex);
//       return;
//     }
//     order.items[itemIndex].process[processIndex].status = newStatus;
//     order.items[itemIndex].process[processIndex].isActive = (newStatus === "completed");
//     await updateDoc(ref, { items: order.items });
//     setOrders((prev) =>
//       prev.map((o) => (o.id === orderId ? { ...o, items: order.items } : o))
//     );
//     setFilteredOrders((prev) =>
//       prev.map((o) => (o.id === orderId ? { ...o, items: order.items } : o))
//     );
//   };

//   const handleCallChange = async (
//     fullname,
//     phone,
//     orderId,
//     itemIndex,
//     processIndex,
//     key,
//     value
//   ) => {
//     addLog(key, `Youvati Call: selected option '${value}'`);
//     if (value === "Call Connected") {
//       await updateStepStatus(orderId, itemIndex, processIndex, "completed");
//     } else {
//       await updateStepStatus(orderId, itemIndex, processIndex, "failed");
//     }
//   };

//   const handleReasonSubmit = async () => {
//     if (!currentAction) return;
//     const { orderId, itemIndex, processIndex, key } = currentAction;
//     addLog(key, `Youvati Call: reason for not connected '${reasonText}'`, reasonText);
//     await updateStepStatus(orderId, itemIndex, processIndex, "failed");
//     setShowReasonModal(false);
//     setReasonText("");
//     setCurrentAction(null);
//   };

//   const handleDesignComplete = async (
//     fullname,
//     phone,
//     orderId,
//     itemIndex,
//     processIndex,
//     key
//   ) => {
//     const result = await Swal.fire({
//       title: "Design Ready",
//       text: "Are you sure you want to mark Design as done?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, mark done",
//     });
//     if (result.isConfirmed) {
//       addLog(key, `Design marked as done`);
//       await updateStepStatus(orderId, itemIndex, processIndex, "completed");
//     }
//   };

//   const openUploadFileModal = (
//     orderId,
//     phoneNo,
//     itemName,
//     itemIndex,
//     processIndex,
//     key
//   ) => {
//     setUploadData({
//       orderId,
//       phoneNo,
//       itemName,
//       itemIndex,
//       processIndex,
//       key,
//       url: "",
//     });
//     setShowUploadModal(true);
//   };

//   const handleUploadSubmit = async () => {
//     const { orderId, phoneNo, itemName, url, itemIndex, processIndex, key } = uploadData;
//     if (!url.trim()) {
//       alert("Please enter a valid URL");
//       return;
//     }
//     try {
//       await addDoc(collection(db, "nv_downloads"), {
//         category: "Design",
//         created_date: new Date(),
//         phone_no: phoneNo,
//         title: itemName,
//         url,
//       });
//       await updateStepStatus(orderId, itemIndex, processIndex, "completed");
//       addLog(key, `File uploaded for step Delivery`);
//       setShowUploadModal(false);
//     } catch (err) {
//       console.error(err);
//       alert("Error uploading file");
//     }
//   };

//   return (
//     <>
//       <div className="p-2 d-flex justify-content-between">
//         <Link to="/">
//           <img src="/images/menubutton.png" alt="Menu" style={{ height: "2rem" }} />
//         </Link>
//       </div>
//       <div className="p-3">
//         <div className="card-header pb-0 px-3 d-flex align-items-center gap-3">
//           <h4>Orders List</h4>
//           <Form.Control
//             type="text"
//             placeholder="Search by Phone Number..."
//             value={searchQuery}
//             onChange={handleSearch}
//             style={{ width: "300px" }}
//           />
//           {/* <Button variant="success" onClick={exportToExcel}>
//             Download Excel
//           </Button> */}
//         </div>

//         <div className="table-responsive fix-width scroll-inner mt-3">
//           <table className="table table-bordered table-hover">
//             <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//               <tr>
//                 <th>Order ID</th>
//                 <th>Full Name</th>
//                 <th>Business Name</th>
//                 <th>Item Name</th>
//                 <th>Item Price</th>
//                 <th>Order Date</th>
//                 <th>Process Steps</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredOrders.map((order) =>
//                 (order.items || []).map((item, itemIndex) => {
//                   const key = `${order.id}-${itemIndex}`;
//                   const logs = logsMap[key] || [];
//                   const callStep = item.process.find((p) => p.step === "Youvati Call");
//                   const designStep = item.process.find((p) => p.step === "Design");
//                   // Note: Make sure your step name for upload/delivery is exactly "Delivery"
//                   const deliveryStep = item.process.find((p) => p.step === "Delivery");

//                   return (
//                     <React.Fragment key={key}>
//                       <tr style={{ background: order.status === "Completed" ? "palegreen" : "" }}>
//                         <td>
//                           {order.id}<br/>
//                           Total Amount: {order.final_total || "N/A"}
//                         </td>
//                         <td>
//                           {order.full_name}<br/>
//                           {order.phone_no}
//                         </td>
//                         <td>{order.business_name}</td>
//                         <td>{item.name}</td>
//                         <td>{item.membership_price}</td>
//                         <td>
//                           {order.order_date ? Moment(order.order_date.toDate()).format("YYYY-MM-DD HH:mm") : "N/A"}
//                         </td>
//                         <td>
//                           <Button size="sm" variant="info" onClick={() => toggleSteps(order.id, itemIndex)}>
//                             {visibleSteps[key] ? "Hide Steps" : "View Steps"}
//                           </Button>
//                         </td>
//                       </tr>

//                       {visibleSteps[key] && (
//                         <tr>
//                           <td colSpan="7" style={{ background: "#fafafa" }}>
//                             {(item.process || []).map((step, processIndex) => (
//                               <div key={`${key}-${processIndex}`} className="d-flex align-items-center justify-content-between mb‑2">
//                                 <strong>{step.step}:</strong>
//                                 <div>
//                                   {step.step === "Youvati Call" && (
//                                     <Form.Select
//                                       size="sm"
//                                       disabled={step.status === "completed"}
//                                       defaultValue="pending"
//                                       onChange={(e) =>
//                                         handleCallChange(
//                                           order.full_name,
//                                           order.phone_no,
//                                           order.id,
//                                           itemIndex,
//                                           processIndex,
//                                           key,
//                                           e.target.value
//                                         )
//                                       }
//                                     >
//                                       <option value="pending">Pending</option>
//                                       <option value="Call Not Connected 1">Call Not Connected 1</option>
//                                       <option value="Call Not Connected 2">Call Not Connected 2</option>
//                                       <option value="Call Not Connected 3">Call Not Connected 3</option>
//                                       <option value="Call Connected">Call Connected</option>
//                                       <option value="Closed">Closed</option>
//                                     </Form.Select>
//                                   )}

//                                   {step.step === "Design" && callStep?.status === "completed" && (
//                                     <Button
//                                       size="sm"
//                                       variant="primary"
//                                       style={{marginTop: "32px"}}
//                                       disabled={step.status === "completed"}
//                                       onClick={() =>
//                                         handleDesignComplete(
//                                           order.full_name,
//                                           order.phone_no,
//                                           order.id,
//                                           itemIndex,
//                                           processIndex,
//                                           key
//                                         )
//                                       }
//                                     >
//                                       {step.status === "completed" ? "Completed" : "Mark Design Completed"}
//                                     </Button>
//                                   )}

//                                   {step.step === "Delivery" && designStep?.status === "completed" && (
//                                     <Button
//                                       size="sm"
//                                       variant="secondary"
//                                       style={{marginTop: "34px"}}
//                                       disabled={step.status === "completed"}
//                                       onClick={() =>
//                                         openUploadFileModal(
//                                           order.id,
//                                           order.phone_no,
//                                           item.name,
//                                           itemIndex,
//                                           processIndex,
//                                           key
//                                         )
//                                       }
//                                     >
//                                       {step.status === "completed" ? "Uploaded" : "Upload File"}
//                                     </Button>
//                                   )}
//                                 </div>
//                               </div>
//                             ))}

//                             <div style={{ marginTop: "1rem", padding: "0.5rem", background: "#fffef0" }}>
//                               <strong>Logs:</strong>
//                               <ul>
//                                 {logs.map((log, idx) => (
//                                   <li key={idx}>
//                                     {Moment(log.timestamp).format("YYYY‑MM‑DD HH:mm:ss")} — {log.action}
//                                     {log.reason ? ` (Reason: ${log.reason})` : ""}
//                                   </li>
//                                 ))}
//                               </ul>
//                             </div>
//                           </td>
//                         </tr>
//                       )}
//                     </React.Fragment>
//                   );
//                 })
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Upload File URL</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form.Group className="mb‑3">
//             <Form.Label>File URL</Form.Label>
//             <Form.Control
//               type="text"
//               placeholder="Enter file URL"
//               value={uploadData.url}
//               onChange={(e) => setUploadData({ ...uploadData, url: e.target.value })}
//             />
//           </Form.Group>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowUploadModal(false)}>
//             Close
//           </Button>
//           <Button variant="primary" onClick={handleUploadSubmit}>
//             Submit
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default OrdersData;


// // import React, { useState, useEffect } from "react";
// // import { Link } from "react-router-dom";
// // import Swal from "sweetalert2";
// // import db from "./Firebase";
// // import {
// //   collection,
// //   doc,
// //   getDoc,
// //   updateDoc,
// //   query,
// //   getDocs,
// //   addDoc,
// //   orderBy,
// // } from "firebase/firestore";
// // import Moment from "moment";
// // import { Button, Form, Modal } from "react-bootstrap";
// // import * as XLSX from "xlsx";

// // const OrdersData = () => {
// //   const [orders, setOrders] = useState([]);
// //   const [filteredOrders, setFilteredOrders] = useState([]);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [visibleSteps, setVisibleSteps] = useState({});
// //   const [showUploadModal, setShowUploadModal] = useState(false);
// //   const [uploadData, setUploadData] = useState({
// //     orderId: "",
// //     phoneNo: "",
// //     itemName: "",
// //     itemIndex: null,
// //     processIndex: null,
// //     key: "",
// //     url: "",
// //   });
// //   const [logsMap, setLogsMap] = useState({});

// //   useEffect(() => {
// //     fetchOrders();
// //   }, []);

// //   const fetchOrders = async () => {
// //     try {
// //       const ordersRef = collection(db, "nv_orders_data");
// //       const q = query(ordersRef, orderBy("order_date", "desc"));
// //       const querySnapshot = await getDocs(q);
// //       const data = [];
// //       querySnapshot.forEach((docSnap) => {
// //         data.push({ id: docSnap.id, ...docSnap.data() });
// //       });
// //       setOrders(data);
// //       setFilteredOrders(data);
// //     } catch (err) {
// //       console.error("Error fetching orders:", err);
// //     }
// //   };

// //   const handleSearch = (e) => {
// //     const q = e.target.value;
// //     setSearchQuery(q);
// //     if (q.trim() === "") setFilteredOrders(orders);
// //     else setFilteredOrders(orders.filter((o) => o.phone_no?.includes(q.trim())));
// //   };

// //   const toggleSteps = (orderId, itemIndex) => {
// //     const key = `${orderId}-${itemIndex}`;
// //     setVisibleSteps((prev) => ({ ...prev, [key]: !prev[key] }));
// //   };

// //   const addLog = (key, action, reason = null) => {
// //     const timestamp = new Date();
// //     setLogsMap((prev) => {
// //       const arr = prev[key] || [];
// //       return { ...prev, [key]: [...arr, { timestamp, action, reason }] };
// //     });
// //   };

// //   const updateStepStatus = async (orderId, itemIndex, processIndex, newStatus) => {
// //     const ref = doc(db, "nv_orders_data", orderId);
// //     const snap = await getDoc(ref);
// //     if (!snap.exists()) return;
// //     const order = snap.data();
// //     order.items[itemIndex].process[processIndex].status = newStatus;
// //     await updateDoc(ref, { items: order.items });
// //     setOrders((prev) =>
// //       prev.map((o) => (o.id === orderId ? { ...o, items: order.items } : o))
// //     );
// //     setFilteredOrders((prev) =>
// //       prev.map((o) => (o.id === orderId ? { ...o, items: order.items } : o))
// //     );
// //   };

// //   const handleCallChange = async (
// //     fullname,
// //     phone,
// //     orderId,
// //     itemIndex,
// //     processIndex,
// //     key,
// //     value
// //   ) => {
// //     addLog(key, `Youvati Call: selected option '${value}'`);
// //     if (value === "Call Connected") {
// //       await updateStepStatus(orderId, itemIndex, processIndex, "completed");
// //     } else {
// //       await updateStepStatus(orderId, itemIndex, processIndex, "failed");
// //     }
// //   };

// //   const handleDesignComplete = async (
// //     fullname,
// //     phone,
// //     orderId,
// //     itemIndex,
// //     processIndex,
// //     key
// //   ) => {
// //     const result = await Swal.fire({
// //       title: "Design Ready",
// //       text: "Mark design as done?",
// //       icon: "question",
// //       showCancelButton: true,
// //       confirmButtonText: "Yes, done",
// //     });
// //     if (result.isConfirmed) {
// //       addLog(key, "Design marked as done");
// //       await updateStepStatus(orderId, itemIndex, processIndex, "completed");
// //     }
// //   };

// //   const openUploadModal = (orderId, phoneNo, itemName, itemIndex, processIndex, key) => {
// //     setUploadData({ orderId, phoneNo, itemName, itemIndex, processIndex, key, url: "" });
// //     setShowUploadModal(true);
// //   };

// //   const handleUploadSubmit = async () => {
// //     const { orderId, phoneNo, itemName, url, itemIndex, processIndex, key } = uploadData;
// //     if (!url.trim()) {
// //       alert("Enter a valid URL");
// //       return;
// //     }
// //     try {
// //       await addDoc(collection(db, "nv_downloads"), {
// //         category: "Design",
// //         created_date: new Date(),
// //         phone_no: phoneNo,
// //         title: itemName,
// //         url,
// //       });
// //       await updateStepStatus(orderId, itemIndex, processIndex, "completed");
// //       addLog(key, "File uploaded for delivery");
// //       setShowUploadModal(false);
// //     } catch (e) {
// //       console.error(e);
// //       alert("Error uploading file");
// //     }
// //   };

// //   return (
// //     <>
// //       <div className="p-2 d-flex justify-content-between">
// //         <Link to="/">
// //           <img src="/images/menubutton.png" style={{ height: "2rem" }} alt="Menu" />
// //         </Link>
// //       </div>

// //       <div className="p-3">
// //         <div className="card-header pb-0 px-3 d-flex align-items-center gap-3">
// //           <h4>Orders List</h4>
// //           <Form.Control
// //             type="text"
// //             placeholder="Search by Phone Number..."
// //             value={searchQuery}
// //             onChange={handleSearch}
// //             style={{ width: "300px" }}
// //           />
// //           <Button
// //             variant="success"
// //             onClick={() => {
// //               const data = filteredOrders.flatMap((o) =>
// //                 o.items.map((i) => ({
// //                   OrderID: o.id,
// //                   Name: o.full_name,
// //                   Phone: o.phone_no,
// //                   Item: i.name,
// //                   Price: i.membership_price,
// //                 }))
// //               );
// //               const ws = XLSX.utils.json_to_sheet(data);
// //               const wb = XLSX.utils.book_new();
// //               XLSX.utils.book_append_sheet(wb, ws, "Orders");
// //               XLSX.writeFile(wb, "Orders.xlsx");
// //             }}
// //           >
// //             Download Excel
// //           </Button>
// //         </div>

// //         <div className="table-responsive mt-3">
// //           <table className="table table-bordered table-hover">
// //             <thead className="thead-dark">
// //               <tr>
// //                 <th>Order ID</th>
// //                 <th>Full Name</th>
// //                 <th>Business</th>
// //                 <th>Item</th>
// //                 <th>Price</th>
// //                 <th>Date</th>
// //                 <th>Steps</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {filteredOrders.map((order) =>
// //                 (order.items || []).map((item, itemIndex) => {
// //                   const key = `${order.id}-${itemIndex}`;
// //                   const logs = logsMap[key] || [];
// //                   const callStep = item.process.find((p) => p.step === "Youvati Call");
// //                   const designStep = item.process.find((p) => p.step === "Design");

// //                   return (
// //                     <React.Fragment key={key}>
// //                       <tr>
// //                         <td>
// //                           {order.id}
// //                           <br />
// //                           Total: {order.final_total}
// //                         </td>
// //                         <td>
// //                           {order.full_name}
// //                           <br />
// //                           {order.phone_no}
// //                         </td>
// //                         <td>{order.business_name}</td>
// //                         <td>{item.name}</td>
// //                         <td>{item.membership_price}</td>
// //                         <td>
// //                           {order.order_date
// //                             ? Moment(order.order_date.toDate()).format("YYYY-MM-DD HH:mm")
// //                             : ""}
// //                         </td>
// //                         <td>
// //                           <Button
// //                             size="sm"
// //                             variant="info"
// //                             onClick={() => toggleSteps(order.id, itemIndex)}
// //                           >
// //                             {visibleSteps[key] ? "Hide" : "View"}
// //                           </Button>
// //                         </td>
// //                       </tr>

// //                       {visibleSteps[key] && (
// //                         <tr>
// //                           <td colSpan="7" style={{ background: "#fafafa" }}>
// //                             {(item.process || []).map((step, processIndex) => (
// //                               <div
// //                                 key={`${key}-${processIndex}`}
// //                                 className="d-flex align-items-center justify-content-between mb-2"
// //                               >
// //                                 <strong>{step.step}:</strong>
// //                                 <div>
// //                                   {step.step === "Youvati Call" && (
// //                                     <Form.Select
// //                                       size="sm"
// //                                       disabled={step.status === "completed"}
// //                                       defaultValue="pending"
// //                                       onChange={(e) =>
// //                                         handleCallChange(
// //                                           order.full_name,
// //                                           order.phone_no,
// //                                           order.id,
// //                                           itemIndex,
// //                                           processIndex,
// //                                           key,
// //                                           e.target.value
// //                                         )
// //                                       }
// //                                     >
// //                                       <option value="pending">Pending</option>
// //                                       <option value="Call Not Connected 1">
// //                                         Call Not Connected 1
// //                                       </option>
// //                                       <option value="Call Not Connected 2">
// //                                         Call Not Connected 2
// //                                       </option>
// //                                       <option value="Call Not Connected 3">
// //                                         Call Not Connected 3
// //                                       </option>
// //                                       <option value="Call Connected">Call Connected</option>
// //                                       <option value="Closed">Closed</option>
// //                                     </Form.Select>
// //                                   )}

// //                                   {step.step === "Design" &&
// //                                     callStep?.status === "completed" && (
// //                                       <Button
// //                                         size="sm"
// //                                         variant="primary"
// //                                         disabled={step.status === "completed"}
// //                                         onClick={() =>
// //                                           handleDesignComplete(
// //                                             order.full_name,
// //                                             order.phone_no,
// //                                             order.id,
// //                                             itemIndex,
// //                                             processIndex,
// //                                             key
// //                                           )
// //                                         }
// //                                       >
// //                                         {step.status === "completed"
// //                                           ? "Completed"
// //                                           : "Mark Design Completed"}
// //                                       </Button>
// //                                     )}

// //                                   {step.step === "Upload File" &&
// //                                     designStep?.status === "completed" && (
// //                                       <Button
// //                                         size="sm"
// //                                         variant="secondary"
// //                                         disabled={step.status === "completed"}
// //                                         onClick={() =>
// //                                           openUploadModal(
// //                                             order.id,
// //                                             order.phone_no,
// //                                             item.name,
// //                                             itemIndex,
// //                                             processIndex,
// //                                             key
// //                                           )
// //                                         }
// //                                       >
// //                                         {step.status === "completed"
// //                                           ? "Uploaded"
// //                                           : "Upload File"}
// //                                       </Button>
// //                                     )}
// //                                 </div>
// //                               </div>
// //                             ))}

// //                             <div
// //                               style={{
// //                                 marginTop: "1rem",
// //                                 padding: "0.5rem",
// //                                 background: "#fffef0",
// //                               }}
// //                             >
// //                               <strong>Logs:</strong>
// //                               <ul>
// //                                 {logs.map((log, i) => (
// //                                   <li key={i}>
// //                                     {Moment(log.timestamp).format("YYYY-MM-DD HH:mm:ss")} —{" "}
// //                                     {log.action}
// //                                     {log.reason ? ` (${log.reason})` : ""}
// //                                   </li>
// //                                 ))}
// //                               </ul>
// //                             </div>
// //                           </td>
// //                         </tr>
// //                       )}
// //                     </React.Fragment>
// //                   );
// //                 })
// //               )}
// //             </tbody>
// //           </table>
// //         </div>
// //       </div>

// //       {/* Upload Modal */}
// //       <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)}>
// //         <Modal.Header closeButton>
// //           <Modal.Title>Upload File URL</Modal.Title>
// //         </Modal.Header>
// //         <Modal.Body>
// //           <Form.Group>
// //             <Form.Label>File URL</Form.Label>
// //             <Form.Control
// //               type="text"
// //               value={uploadData.url}
// //               onChange={(e) =>
// //                 setUploadData({ ...uploadData, url: e.target.value })
// //               }
// //               placeholder="Enter file URL"
// //             />
// //           </Form.Group>
// //         </Modal.Body>
// //         <Modal.Footer>
// //           <Button variant="secondary" onClick={() => setShowUploadModal(false)}>
// //             Close
// //           </Button>
// //           <Button variant="primary" onClick={handleUploadSubmit}>
// //             Submit
// //           </Button>
// //         </Modal.Footer>
// //       </Modal>
// //     </>
// //   );
// // };

// // export default OrdersData;


// // // import React, { useState, useEffect } from "react";
// // // import { Link } from "react-router-dom";
// // // import Swal from "sweetalert2";
// // // import db from "./Firebase";
// // // import {
// // //   collection,
// // //   doc,
// // //   getDoc,
// // //   updateDoc,
// // //   query,
// // //   where,
// // //   getDocs,
// // //   addDoc,
// // //   orderBy,
// // // } from "firebase/firestore";
// // // import Moment from "moment";
// // // import { Button, Form, Modal } from "react-bootstrap";
// // // import * as XLSX from "xlsx";

// // // const OrdersData = () => {
// // //   const [orders, setOrders] = useState([]);
// // //   const [filteredOrders, setFilteredOrders] = useState([]);
// // //   const [searchQuery, setSearchQuery] = useState("");
// // //   const [visibleSteps, setVisibleSteps] = useState({}); // track which item’s steps are visible

// // //   // For upload file modal
// // //   const [showUploadModal, setShowUploadModal] = useState(false);
// // //   const [uploadData, setUploadData] = useState({
// // //     orderId: "",
// // //     phoneNo: "",
// // //     itemName: "",
// // //     itemIndex: null,
// // //     processIndex: null,
// // //     key: "",
// // //     url: "",
// // //   });

// // //   // For call‑not‑connected reason modal
// // //   const [showReasonModal, setShowReasonModal] = useState(false);
// // //   const [reasonText, setReasonText] = useState("");
// // //   const [currentAction, setCurrentAction] = useState(null); // { orderId, itemIndex, processIndex, key, fullname, phone }

// // //   // Logs per item
// // //   const [logsMap, setLogsMap] = useState({}); // key => array of { timestamp, action, reason? }

// // //   useEffect(() => {
// // //     fetchOrders();
// // //   }, []);

// // //   const fetchOrders = async () => {
// // //     try {
// // //       const ordersRef = collection(db, "nv_orders_data");
// // //       const q = query(ordersRef, orderBy("order_date", "desc"));
// // //       const querySnapshot = await getDocs(q);
// // //       const ordersData = [];
// // //       querySnapshot.forEach((docSnap) => {
// // //         ordersData.push({ id: docSnap.id, ...docSnap.data() });
// // //       });
// // //       setOrders(ordersData);
// // //       setFilteredOrders(ordersData);
// // //     } catch (error) {
// // //       console.error("Error fetching orders:", error);
// // //     }
// // //   };

// // //   const handleSearch = (event) => {
// // //     const queryTerm = event.target.value;
// // //     setSearchQuery(queryTerm);
// // //     if (queryTerm.trim() === "") {
// // //       setFilteredOrders(orders);
// // //     } else {
// // //       setFilteredOrders(
// // //         orders.filter((order) =>
// // //           (order.phone_no || "").includes(queryTerm.trim())
// // //         )
// // //       );
// // //     }
// // //   };

// // //   const exportToExcel = () => {
// // //     const formattedData = [];
// // //     filteredOrders.forEach((order) => {
// // //       (order.items || []).forEach((item) => {
// // //         formattedData.push({
// // //           "Order ID": order.id,
// // //           "Full Name": order.full_name,
// // //           "Phone No": order.phone_no,
// // //           "Business Name": order.business_name,
// // //           "Order Date": order.order_date
// // //             ? Moment(order.order_date.toDate()).format("DD/MM/YY, h:mm a")
// // //             : "",
// // //           Status: order.status,
// // //           "Total Amount": order.final_total,
// // //           "Item Name": item.name,
// // //           "Item Price": `${item.membership_price}`,
// // //           "Item Type": item.type,
// // //           "Process Status": (item.process || [])
// // //             .map((step) => `${step.step}: ${step.status}`)
// // //             .join(" | "),
// // //         });
// // //       });
// // //     });
// // //     const ws = XLSX.utils.json_to_sheet(formattedData);
// // //     const wb = XLSX.utils.book_new();
// // //     XLSX.utils.book_append_sheet(wb, ws, "Orders");
// // //     XLSX.writeFile(wb, "OrdersData.xlsx");
// // //   };

// // //   const toggleSteps = (orderId, itemIndex) => {
// // //     const key = `${orderId}-${itemIndex}`;
// // //     setVisibleSteps((prev) => ({
// // //       ...prev,
// // //       [key]: !prev[key],
// // //     }));
// // //   };

// // //   const addLog = (key, action, reason = null) => {
// // //     const timestamp = new Date();
// // //     setLogsMap((prev) => {
// // //       const arr = prev[key] || [];
// // //       return {
// // //         ...prev,
// // //         [key]: [...arr, { timestamp, action, reason }],
// // //       };
// // //     });
// // //   };

// // //   const updateStepStatus = async (
// // //     orderId,
// // //     itemIndex,
// // //     processIndex,
// // //     newStatus
// // //   ) => {
// // //     const orderRef = doc(db, "nv_orders_data", orderId);
// // //     const orderSnap = await getDoc(orderRef);
// // //     if (!orderSnap.exists()) return;
// // //     const updatedOrder = orderSnap.data();
// // //     if (
// // //       !updatedOrder.items ||
// // //       !updatedOrder.items[itemIndex] ||
// // //       !updatedOrder.items[itemIndex].process
// // //     ) {
// // //       console.warn(
// // //         "Invalid indices for updateStepStatus",
// // //         orderId,
// // //         itemIndex,
// // //         processIndex
// // //       );
// // //       return;
// // //     }
// // //     updatedOrder.items[itemIndex].process[processIndex].status = newStatus;
// // //     updatedOrder.items[itemIndex].process[processIndex].isActive =
// // //       newStatus === "completed";
// // //     await updateDoc(orderRef, { items: updatedOrder.items });
// // //     // Update local state
// // //     setOrders((prev) =>
// // //       prev.map((o) => (o.id === orderId ? { ...o, items: updatedOrder.items } : o))
// // //     );
// // //     setFilteredOrders((prev) =>
// // //       prev.map((o) => (o.id === orderId ? { ...o, items: updatedOrder.items } : o))
// // //     );
// // //   };

// // //   const handleReasonSubmit = async () => {
// // //     if (!currentAction) return;
// // //     const {
// // //       orderId,
// // //       itemIndex,
// // //       processIndex,
// // //       key,
// // //       fullname = "",
// // //       phone = "",
// // //     } = currentAction;
// // //     addLog(key, `Youvati Call: call not connected`, reasonText);
// // //     await updateStepStatus(orderId, itemIndex, processIndex, "failed");
// // //     setShowReasonModal(false);
// // //     setReasonText("");
// // //     setCurrentAction(null);
// // //   };

// // //   const openUploadFileModal = (
// // //     orderId,
// // //     phoneNo,
// // //     itemName,
// // //     itemIndex,
// // //     processIndex,
// // //     key
// // //   ) => {
// // //     setUploadData({
// // //       orderId,
// // //       phoneNo,
// // //       itemName,
// // //       url: "",
// // //       itemIndex,
// // //       processIndex,
// // //       key,
// // //     });
// // //     setShowUploadModal(true);
// // //   };

// // //   const handleUploadSubmit = async () => {
// // //     const {
// // //       orderId,
// // //       phoneNo,
// // //       itemName,
// // //       url,
// // //       itemIndex,
// // //       processIndex,
// // //       key,
// // //     } = uploadData;
// // //     if (!url) {
// // //       alert("Please enter a valid URL");
// // //       return;
// // //     }
// // //     try {
// // //       await addDoc(collection(db, "nv_downloads"), {
// // //         category: "Design",
// // //         created_date: new Date(),
// // //         date: new Date(),
// // //         image: "",
// // //         phone_no: phoneNo,
// // //         selected: false,
// // //         title: itemName,
// // //         url: url,
// // //       });
// // //       await updateStepStatus(orderId, itemIndex, processIndex, "completed");
// // //       addLog(key, `File uploaded for step Upload File`);
// // //       setShowUploadModal(false);
// // //       alert("File uploaded successfully!");
// // //     } catch (error) {
// // //       console.error("Error uploading file:", error);
// // //       alert("Error uploading file");
// // //     }
// // //   };

// // //   const handleCallOptionChange = async (
// // //     fullname,
// // //     phone,
// // //     orderId,
// // //     itemIndex,
// // //     processIndex,
// // //     key,
// // //     selectedOption
// // //   ) => {
// // //     // selectedOption: one of those you specified
// // //     addLog(key, `Youvati Call: selected option '${selectedOption}'`);
// // //     if (selectedOption === "Call Connected") {
// // //       await updateStepStatus(orderId, itemIndex, processIndex, "completed");
// // //       // optionally: sendDesignReady(phone, fullname);
// // //     } else {
// // //       // Not connected or closed
// // //       await updateStepStatus(orderId, itemIndex, processIndex, "failed");
// // //       if (selectedOption.startsWith("Call Not Connected")) {
// // //         // optionally: sendCallNotConnected(phone, fullname);
// // //       }
// // //     }
// // //   };

// // //   const handleDesignComplete = async (
// // //     fullname,
// // //     phone,
// // //     orderId,
// // //     itemIndex,
// // //     processIndex,
// // //     key
// // //   ) => {
// // //     const result = await Swal.fire({
// // //       title: "Design Ready",
// // //       text: "Are you sure you want to mark Design as done?",
// // //       icon: "warning",
// // //       showCancelButton: true,
// // //       confirmButtonText: "Yes, mark done",
// // //     });
// // //     if (result.isConfirmed) {
// // //       addLog(key, `Design marked as done`);
// // //       await updateStepStatus(orderId, itemIndex, processIndex, "completed");
// // //       // optionally: sendDesignReady(phone, fullname);
// // //     }
// // //   };

// // //   return (
// // //     <>
// // //       <div
// // //         className="p-2"
// // //         style={{
// // //           paddingBottom: "5px",
// // //           display: "flex",
// // //           justifyContent: "space-between",
// // //         }}
// // //       >
// // //         <Link to="/">
// // //           <img
// // //             src="/images/menubutton.png"
// // //             className="menu-toggle"
// // //             alt="Menu"
// // //             style={{ height: "2rem" }}
// // //           />
// // //         </Link>
// // //       </div>

// // //       <div className="p‑3">
// // //         <div className="card-header pb‑0 px‑3 d‑flex align‑items‑center gap‑3">
// // //           <h4 className="mb‑2">Orders List</h4>
// // //           <Form.Control
// // //             type="text"
// // //             placeholder="Search by Phone Number..."
// // //             value={searchQuery}
// // //             onChange={handleSearch}
// // //             style={{ width: "300px" }}
// // //           />
// // //           <Button variant="success" onClick={exportToExcel}>
// // //             Download Excel
// // //           </Button>
// // //         </div>

// // //         <div className="table-responsive fix-width scroll-inner mt‑3">
// // //           <table className="table table-bordered table-hover">
// // //             <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// // //               <tr>
// // //                 <th>Order ID</th>
// // //                 <th>Full Name</th>
// // //                 <th>Business Name</th>
// // //                 <th>Item Name</th>
// // //                 <th>Item Price</th>
// // //                 <th>Order Date</th>
// // //                 <th>Process Steps</th>
// // //               </tr>
// // //             </thead>
// // //             <tbody>
// // //               {filteredOrders.map((order) =>
// // //                 (order.items || []).map((item, itemIndex) => {
// // //                   const key = `${order.id}-${itemIndex}`;
// // //                   const logs = logsMap[key] || [];
// // //                   return (
// // //                     <React.Fragment key={key}>
// // //                       <tr
// // //                         style={{
// // //                           background:
// // //                             order.status === "Completed" ? "palegreen" : "",
// // //                         }}
// // //                       >
// // //                         <td>
// // //                           {order.id || "N/A"}{" "}
// // //                           <p>Total Amount: {order.final_total || "N/A"}</p>
// // //                         </td>
// // //                         <td>
// // //                           {order.full_name || "N/A"}{" "}
// // //                           <p>{order.phone_no || "N/A"}</p>
// // //                         </td>
// // //                         <td>{order.business_name}</td>
// // //                         <td>{item.name}</td>
// // //                         <td>{item.membership_price}</td>
// // //                         <td>
// // //                           {order.order_date
// // //                             ? Moment(order.order_date.toDate()).format(
// // //                                 "YYYY‑MM‑DD HH:mm"
// // //                               )
// // //                             : "N/A"}
// // //                         </td>
// // //                         <td>
// // //                           <Button
// // //                             variant="info"
// // //                             size="sm"
// // //                             onClick={() => toggleSteps(order.id, itemIndex)}
// // //                           >
// // //                             {visibleSteps[key] ? "Hide Steps" : "View Steps"}
// // //                           </Button>
// // //                         </td>
// // //                       </tr>

// // //                       {visibleSteps[key] && (
// // //                         <tr>
// // //                           <td colSpan="7" style={{ background: "#fafafa" }}>
                            
// // //                           {(item.process || []).map((step, processIndex) => (
// // //   <div key={`${key}-${processIndex}`} className="d-flex align-items-center justify-content-between mb-2">
// // //     <strong>{step.step}:</strong>
// // //     <div>
// // //       {step.step === "Youvati Call" && (
// // //         <Form.Select
// // //           size="sm"
// // //           disabled={step.status === "completed"}
// // //           defaultValue="pending"
// // //           onChange={(e) =>
// // //             handleCallOptionChange(
// // //               order.full_name,
// // //               order.phone_no,
// // //               order.id,
// // //               itemIndex,
// // //               processIndex,
// // //               key,
// // //               e.target.value
// // //             )
// // //           }
// // //         >
// // //           <option value="pending">Pending</option>
// // //           <option value="Call Not Connected 1">Call Not Connected 1</option>
// // //           <option value="Call Not Connected 2">Call Not Connected 2</option>
// // //           <option value="Call Not Connected 3">Call Not Connected 3</option>
// // //           <option value="Call Connected">Call Connected</option>
// // //           <option value="Closed">Closed</option>
// // //         </Form.Select>
// // //       )}

// // //       {step.step === "Design" && callStep?.status === "completed" && (
// // //         <Button
// // //           variant="primary"
// // //           size="sm"
// // //           disabled={step.status === "completed"}
// // //           onClick={() =>
// // //             handleDesignComplete(
// // //               order.full_name,
// // //               order.phone_no,
// // //               order.id,
// // //               itemIndex,
// // //               processIndex,
// // //               key
// // //             )
// // //           }
// // //         >
// // //           {step.status === "completed" ? "Completed" : "Mark Design Completed"}
// // //         </Button>
// // //       )}

// // //       {step.step === "Upload File" && designStep?.status === "completed" && (
// // //         <Button
// // //           variant="secondary"
// // //           size="sm"
// // //           disabled={step.status === "completed"}
// // //           onClick={() =>
// // //             openUploadFileModal(
// // //               order.id,
// // //               order.phone_no,
// // //               item.name,
// // //               itemIndex,
// // //               processIndex,
// // //               key
// // //             )
// // //           }
// // //         >
// // //           {step.status === "completed" ? "Uploaded" : "Upload File"}
// // //         </Button>
// // //       )}
// // //     </div>
// // //   </div>
// // // ))}


// // //                             <div
// // //                               style={{
// // //                                 marginTop: "1rem",
// // //                                 padding: "0.5rem",
// // //                                 background: "#fffef0",
// // //                               }}
// // //                             >
// // //                               <strong>Logs:</strong>
// // //                               <ul>
// // //                                 {logs.map((log, idx) => (
// // //                                   <li key={idx}>
// // //                                     {Moment(log.timestamp).format(
// // //                                       "YYYY‑MM‑DD HH:mm:ss"
// // //                                     )}{" "}
// // //                                     — {log.action}
// // //                                     {log.reason ? ` (Reason: ${log.reason})` : ""}
// // //                                   </li>
// // //                                 ))}
// // //                               </ul>
// // //                             </div>
// // //                           </td>
// // //                         </tr>
// // //                       )}
// // //                     </React.Fragment>
// // //                   );
// // //                 })
// // //               )}
// // //             </tbody>
// // //           </table>
// // //         </div>

// // //         {/* Reason Modal */}
// // //         <Modal
// // //           show={showReasonModal}
// // //           onHide={() => setShowReasonModal(false)}
// // //         >
// // //           <Modal.Header closeButton>
// // //             <Modal.Title>Reason for Call Not Connected</Modal.Title>
// // //           </Modal.Header>
// // //           <Modal.Body>
// // //             <Form.Group className="mb‑3">
// // //               <Form.Label>Reason</Form.Label>
// // //               <Form.Control
// // //                 as="textarea"
// // //                 rows={3}
// // //                 value={reasonText}
// // //                 onChange={(e) => setReasonText(e.target.value)}
// // //               />
// // //             </Form.Group>
// // //           </Modal.Body>
// // //           <Modal.Footer>
// // //             <Button
// // //               variant="secondary"
// // //               onClick={() => setShowReasonModal(false)}
// // //             >
// // //               Cancel
// // //             </Button>
// // //             <Button variant="primary" onClick={handleReasonSubmit}>
// // //               Submit
// // //             </Button>
// // //           </Modal.Footer>
// // //         </Modal>

// // //         {/* Upload File Modal */}
// // //         <Modal
// // //           show={showUploadModal}
// // //           onHide={() => setShowUploadModal(false)}
// // //         >
// // //           <Modal.Header closeButton>
// // //             <Modal.Title>Upload File URL</Modal.Title>
// // //           </Modal.Header>
// // //           <Modal.Body>
// // //             <Form.Group className="mb‑3">
// // //               <Form.Label>File URL</Form.Label>
// // //               <Form.Control
// // //                 type="text"
// // //                 placeholder="Enter file URL"
// // //                 value={uploadData.url}
// // //                 onChange={(e) =>
// // //                   setUploadData({ ...uploadData, url: e.target.value })
// // //                 }
// // //               />
// // //             </Form.Group>
// // //           </Modal.Body>
// // //           <Modal.Footer>
// // //             <Button
// // //               variant="secondary"
// // //               onClick={() => setShowUploadModal(false)}
// // //             >
// // //               Close
// // //             </Button>
// // //             <Button variant="primary" onClick={handleUploadSubmit}>
// // //               Submit
// // //             </Button>
// // //           </Modal.Footer>
// // //         </Modal>
// // //       </div>
// // //     </>
// // //   );
// // // };

// // // export default OrdersData;


// // // // import React, { useState, useEffect } from "react";
// // // // import { Link } from "react-router-dom";
// // // // import Swal from "sweetalert2";
// // // // import db from "./Firebase";
// // // // import {
// // // //     collection,
// // // //     doc,
// // // //     getDoc,
// // // //     updateDoc,
// // // //     query,
// // // //     where,
// // // //     getDocs,
// // // //     addDoc,
// // // //     orderBy,
// // // // } from "firebase/firestore";
// // // // import Moment from "moment";
// // // // import { Button, Form, Modal } from "react-bootstrap";
// // // // import * as XLSX from "xlsx";

// // // // const OrdersData = () => {
// // // //     const [orders, setOrders] = useState([]);
// // // //     const [filteredOrders, setFilteredOrders] = useState([]);
// // // //     const [searchQuery, setSearchQuery] = useState("");
// // // //     const [visibleSteps, setVisibleSteps] = useState({}); // track which item’s steps are visible

// // // //     // For upload file modal
// // // //     const [showUploadModal, setShowUploadModal] = useState(false);
// // // //     const [uploadData, setUploadData] = useState({
// // // //         orderId: "",
// // // //         phoneNo: "",
// // // //         itemName: "",
// // // //         itemIndex: null,
// // // //         processIndex: null,
// // // //         key: "",
// // // //         url: "",
// // // //     });

// // // //     // For call-not-connected reason modal
// // // //     const [showReasonModal, setShowReasonModal] = useState(false);
// // // //     const [reasonText, setReasonText] = useState("");
// // // //     const [currentAction, setCurrentAction] = useState(null); // { orderId, itemIndex, processIndex, key }

// // // //     // Logs per item
// // // //     const [logsMap, setLogsMap] = useState({}); // key => array of { timestamp, action, reason? }

// // // //     useEffect(() => {
// // // //         fetchOrders();
// // // //     }, []);

// // // //     const fetchOrders = async () => {
// // // //         try {
// // // //             const ordersRef = collection(db, "nv_orders_data");
// // // //             const q = query(ordersRef, orderBy("order_date", "desc"));
// // // //             const querySnapshot = await getDocs(q);
// // // //             const ordersData = [];
// // // //             querySnapshot.forEach((docSnap) => {
// // // //                 ordersData.push({ id: docSnap.id, ...docSnap.data() });
// // // //             });
// // // //             setOrders(ordersData);
// // // //             setFilteredOrders(ordersData);
// // // //         } catch (error) {
// // // //             console.error("Error fetching orders:", error);
// // // //         }
// // // //     };

// // // //     const handleSearch = (event) => {
// // // //         const queryTerm = event.target.value;
// // // //         setSearchQuery(queryTerm);
// // // //         if (queryTerm.trim() === "") {
// // // //             setFilteredOrders(orders);
// // // //         } else {
// // // //             setFilteredOrders(
// // // //                 orders.filter((order) =>
// // // //                     (order.phone_no || "").includes(queryTerm.trim())
// // // //                 )
// // // //             );
// // // //         }
// // // //     };

    

// // // //     const exportToExcel = () => {
// // // //         const formattedData = [];
// // // //         filteredOrders.forEach((order) => {
// // // //             (order.items || []).forEach((item) => {
// // // //                 formattedData.push({
// // // //                     "Order ID": order.id,
// // // //                     "Full Name": order.full_name,
// // // //                     "Phone No": order.phone_no,
// // // //                     "Business Name": order.business_name,
// // // //                     "Order Date": Moment(order.order_date.toDate()).format(
// // // //                         "DD/MM/YY, h:mm a"
// // // //                     ),
// // // //                     Status: order.status,
// // // //                     "Total Amount": order.final_total,
// // // //                     "Item Name": item.name,
// // // //                     "Item Price": `${item.membership_price}`,
// // // //                     "Item Type": item.type,
// // // //                     "Process Status": (item.process || [])
// // // //                         .map((step) => `${step.step}: ${step.status}`)
// // // //                         .join(" | "),
// // // //                 });
// // // //             });
// // // //         });
// // // //         const ws = XLSX.utils.json_to_sheet(formattedData);
// // // //         const wb = XLSX.utils.book_new();
// // // //         XLSX.utils.book_append_sheet(wb, ws, "Orders");
// // // //         XLSX.writeFile(wb, "OrdersData.xlsx");
// // // //     };

// // // //     const toggleSteps = (orderId, itemIndex) => {
// // // //         const key = `${orderId}-${itemIndex}`;
// // // //         setVisibleSteps((prev) => ({
// // // //             ...prev,
// // // //             [key]: !prev[key],
// // // //         }));
// // // //     };

// // // //     const addLog = (key, action, reason = null) => {
// // // //         const timestamp = new Date();
// // // //         setLogsMap((prev) => {
// // // //             const arr = prev[key] || [];
// // // //             return {
// // // //                 ...prev,
// // // //                 [key]: [...arr, { timestamp, action, reason }],
// // // //             };
// // // //         });
// // // //     };

// // // //     const updateStepStatus = async (orderId, itemIndex, processIndex, newStatus) => {
// // // //         const orderRef = doc(db, "nv_orders_data", orderId);
// // // //         const orderSnap = await getDoc(orderRef);
// // // //         if (!orderSnap.exists()) return;
// // // //         const updatedOrder = orderSnap.data();
// // // //         if (
// // // //             !updatedOrder.items ||
// // // //             !updatedOrder.items[itemIndex] ||
// // // //             !updatedOrder.items[itemIndex].process
// // // //         ) {
// // // //             console.warn("Invalid indices for updateStepStatus", orderId, itemIndex, processIndex);
// // // //             return;
// // // //         }
// // // //         updatedOrder.items[itemIndex].process[processIndex].status = newStatus;
// // // //         updatedOrder.items[itemIndex].process[processIndex].isActive = newStatus === "completed";
// // // //         await updateDoc(orderRef, { items: updatedOrder.items });
// // // //         // Update local state
// // // //         setOrders((prev) =>
// // // //             prev.map((o) => (o.id === orderId ? { ...o, items: updatedOrder.items } : o))
// // // //         );
// // // //         setFilteredOrders((prev) =>
// // // //             prev.map((o) => (o.id === orderId ? { ...o, items: updatedOrder.items } : o))
// // // //         );
// // // //     };

// // // //     const handleReasonSubmit = async () => {
// // // //         if (!currentAction) return;
// // // //         const { orderId, itemIndex, processIndex, key, fullname = "", phone = "" } = currentAction;
// // // //         addLog(key, `Call not connected`, reasonText);
// // // //         // mark status maybe “failed” or leave pending
// // // //         await updateStepStatus(orderId, itemIndex, processIndex, "failed");
// // // //         setShowReasonModal(false);
// // // //         setReasonText("");
// // // //         setCurrentAction(null);
// // // //     };

// // // //     const openUploadFileModal = (orderId, phoneNo, itemName, itemIndex, processIndex, key) => {
// // // //         setUploadData({
// // // //             orderId,
// // // //             phoneNo,
// // // //             itemName,
// // // //             url: "",
// // // //             itemIndex,
// // // //             processIndex,
// // // //             key,
// // // //         });
// // // //         setShowUploadModal(true);
// // // //     };

// // // //     const handleUploadSubmit = async () => {
// // // //         const { orderId, phoneNo, itemName, url, itemIndex, processIndex, key } = uploadData;
// // // //         if (!url) {
// // // //             alert("Please enter a valid URL");
// // // //             return;
// // // //         }
// // // //         try {
// // // //             await addDoc(collection(db, "nv_downloads"), {
// // // //                 category: "Design",
// // // //                 created_date: new Date(),
// // // //                 date: new Date(),
// // // //                 image: "",
// // // //                 phone_no: phoneNo,
// // // //                 selected: false,
// // // //                 title: itemName,
// // // //                 url: url,
// // // //             });
// // // //             // (Optional) notifications logic etc.

// // // //             await updateStepStatus(orderId, itemIndex, processIndex, "completed");
// // // //             addLog(key, `File uploaded for step Upload File`);

// // // //             setShowUploadModal(false);
// // // //             alert("File uploaded successfully!");
// // // //         } catch (error) {
// // // //             console.error("Error uploading file:", error);
// // // //             alert("Error uploading file");
// // // //         }
// // // //     };

// // // //     const handleStatusDropdownChange = async (
// // // //         fullname,
// // // //         phone,
// // // //         orderId,
// // // //         itemIndex,
// // // //         processIndex,
// // // //         stepObj,
// // // //         newStatus
// // // //     ) => {
// // // //         const stepName = stepObj.step;
// // // //         const key = `${orderId}-${itemIndex}`;
// // // //         // newStatus might be one of “pending”, “calling”, “design”, “upload” etc
// // // //         if (stepName === "Calling" && newStatus === "calling") {
// // // //             Swal.fire({
// // // //                 title: "Call Status",
// // // //                 text: "Was the call connected?",
// // // //                 icon: "question",
// // // //                 showCancelButton: true,
// // // //                 confirmButtonText: "Call Connected",
// // // //                 cancelButtonText: "Call Not Connected",
// // // //                 reverseButtons: true,
// // // //             }).then(async (result) => {
// // // //                 if (result.isConfirmed) {
// // // //                     addLog(key, `Call connected for step ${stepName}`);
// // // //                     await updateStepStatus(orderId, itemIndex, processIndex, "completed");
// // // //                 } else {
// // // //                     // Not connected → show reason modal
// // // //                     setCurrentAction({ orderId, itemIndex, processIndex, key, fullname, phone });
// // // //                     setShowReasonModal(true);
// // // //                 }
// // // //             });
// // // //         } else if (stepName === "Design" && newStatus === "design") {
// // // //             const result = await Swal.fire({
// // // //                 title: "Design Ready",
// // // //                 text: "Are you sure you want to mark Design as done?",
// // // //                 icon: "warning",
// // // //                 showCancelButton: true,
// // // //                 confirmButtonText: "Yes, mark done",
// // // //             });
// // // //             if (result.isConfirmed) {
// // // //                 addLog(key, `Design marked as done`);
// // // //                 await updateStepStatus(orderId, itemIndex, processIndex, "completed");
// // // //             }
// // // //         } else if (stepName === "Upload File" && newStatus === "upload") {
// // // //             openUploadFileModal(orderId, phone, stepObj.step, itemIndex, processIndex, key);
// // // //         } else {
// // // //             // generic change (for example Pending → something else)
// // // //             addLog(key, `Status changed for step ${stepName} to ${newStatus}`);
// // // //             await updateStepStatus(orderId, itemIndex, processIndex, newStatus);
// // // //         }
// // // //     };

// // // //     return (
// // // //         <>
// // // //             <div
// // // //                 className="p-2"
// // // //                 style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}
// // // //             >
// // // //                 <Link to="/">
// // // //                     <img
// // // //                         src="/images/menubutton.png"
// // // //                         className="menu-toggle"
// // // //                         alt="Menu"
// // // //                         style={{ height: "2rem" }}
// // // //                     />
// // // //                 </Link>
// // // //             </div>

// // // //             <div className="p-3">
// // // //                 <div className="card-header pb-0 px-3 d-flex align-items-center gap-3">
// // // //                     <h4 className="mb-2">Orders List</h4>
// // // //                     <Form.Control
// // // //                         type="text"
// // // //                         placeholder="Search by Phone Number..."
// // // //                         value={searchQuery}
// // // //                         onChange={handleSearch}
// // // //                         style={{ width: "300px" }}
// // // //                     />
// // // //                     <Button variant="success" onClick={exportToExcel}>
// // // //                         Download Excel
// // // //                     </Button>
// // // //                 </div>

// // // //                 <div className="table-responsive fix-width scroll-inner mt-3">
// // // //                     <table className="table table-bordered table-hover">
// // // //                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// // // //                             <tr>
// // // //                                 <th>Order ID</th>
// // // //                                 <th>Full Name</th>
// // // //                                 <th>Business Name</th>
// // // //                                 <th>Item Name</th>
// // // //                                 <th>Item Price</th>
// // // //                                 <th>Order Date</th>
// // // //                                 <th>Process Steps</th>
// // // //                             </tr>
// // // //                         </thead>
// // // //                         <tbody>
// // // //                             {filteredOrders.map((order) =>
// // // //                                 (order.items || []).map((item, itemIndex) => {
// // // //                                     const key = `${order.id}-${itemIndex}`;
// // // //                                     const logs = logsMap[key] || [];
// // // //                                     return (
// // // //                                         <React.Fragment key={key}>
// // // //                                             <tr style={{ background: order.status === "Completed" ? "palegreen" : "" }}>
// // // //                                                 <td>
// // // //                                                     {order.id || "N/A"} <p>Total Amount: {order.final_total || "N/A"}</p>
// // // //                                                 </td>
// // // //                                                 <td>
// // // //                                                     {order.full_name || "N/A"} <p>{order.phone_no || "N/A"}</p>
// // // //                                                 </td>
// // // //                                                 <td>{order.business_name}</td>
// // // //                                                 <td>{item.name}</td>
// // // //                                                 <td>{item.membership_price}</td>
// // // //                                                 <td>
// // // //                                                     {order.order_date
// // // //                                                         ? Moment(order.order_date.toDate()).format("YYYY-MM-DD HH:mm")
// // // //                                                         : "N/A"}
// // // //                                                 </td>
// // // //                                                 <td>
// // // //                                                     <Button
// // // //                                                         variant="info"
// // // //                                                         size="sm"
// // // //                                                         onClick={() => toggleSteps(order.id, itemIndex)}
// // // //                                                     >
// // // //                                                         {visibleSteps[key] ? "Hide Steps" : "View Steps"}
// // // //                                                     </Button>
// // // //                                                 </td>
// // // //                                             </tr>

// // // //                                             {visibleSteps[key] && (
// // // //                                                 <tr>
// // // //                                                     <td colSpan="7" style={{ background: "#fafafa" }}>
// // // //                                                         {(item.process || []).map((step, processIndex) => (
// // // //                                                             <div
// // // //                                                                 key={`${key}-${processIndex}`}
// // // //                                                                 className="d-flex align-items-center justify-content-between mb-2"
// // // //                                                             >
// // // //                                                                 <strong>{step.step}:</strong>
// // // //                                                                 <div>
// // // //                                                                     <Form.Select
// // // //                                                                         size="sm"
// // // //                                                                         value={step.status}
// // // //                                                                         onChange={(e) =>
// // // //                                                                             handleStatusDropdownChange(
// // // //                                                                                 order.full_name,
// // // //                                                                                 order.phone_no,
// // // //                                                                                 order.id,
// // // //                                                                                 itemIndex,
// // // //                                                                                 processIndex,
// // // //                                                                                 step,
// // // //                                                                                 e.target.value
// // // //                                                                             )
// // // //                                                                         }
// // // //                                                                         disabled={step.status === "completed"}
// // // //                                                                     >
// // // //                                                                         <option value="pending">Pending</option>
// // // //                                                                         <option value="calling">Calling</option>
// // // //                                                                         <option value="design">Design</option>
// // // //                                                                         <option value="upload">Upload File</option>
// // // //                                                                     </Form.Select>
// // // //                                                                 </div>
// // // //                                                             </div>
// // // //                                                         ))}

// // // //                                                         <div style={{ marginTop: "1rem", padding: "0.5rem", background: "#fffef0" }}>
// // // //                                                             <strong>Logs:</strong>
// // // //                                                             <ul>
// // // //                                                                 {logs.map((log, idx) => (
// // // //                                                                     <li key={idx}>
// // // //                                                                         {Moment(log.timestamp).format("YYYY-MM-DD HH:mm:ss")} — {log.action}
// // // //                                                                         {log.reason ? ` (Reason: ${log.reason})` : ""}
// // // //                                                                     </li>
// // // //                                                                 ))}
// // // //                                                             </ul>
// // // //                                                         </div>
// // // //                                                     </td>
// // // //                                                 </tr>
// // // //                                             )}
// // // //                                         </React.Fragment>
// // // //                                     );
// // // //                                 })
// // // //                             )}
// // // //                         </tbody>
// // // //                     </table>
// // // //                 </div>

// // // //                 {/* Reason Modal */}
// // // //                 <Modal show={showReasonModal} onHide={() => setShowReasonModal(false)}>
// // // //                     <Modal.Header closeButton>
// // // //                         <Modal.Title>Reason for Call Not Connected</Modal.Title>
// // // //                     </Modal.Header>
// // // //                     <Modal.Body>
// // // //                         <Form.Group className="mb-3">
// // // //                             <Form.Label>Reason</Form.Label>
// // // //                             <Form.Control
// // // //                                 as="textarea"
// // // //                                 rows={3}
// // // //                                 value={reasonText}
// // // //                                 onChange={(e) => setReasonText(e.target.value)}
// // // //                             />
// // // //                         </Form.Group>
// // // //                     </Modal.Body>
// // // //                     <Modal.Footer>
// // // //                         <Button variant="secondary" onClick={() => setShowReasonModal(false)}>
// // // //                             Cancel
// // // //                         </Button>
// // // //                         <Button variant="primary" onClick={handleReasonSubmit}>
// // // //                             Submit
// // // //                         </Button>
// // // //                     </Modal.Footer>
// // // //                 </Modal>

// // // //                 {/* Upload File Modal */}
// // // //                 <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)}>
// // // //                     <Modal.Header closeButton>
// // // //                         <Modal.Title>Upload File URL</Modal.Title>
// // // //                     </Modal.Header>
// // // //                     <Modal.Body>
// // // //                         <Form.Group className="mb-3">
// // // //                             <Form.Label>File URL</Form.Label>
// // // //                             <Form.Control
// // // //                                 type="text"
// // // //                                 placeholder="Enter file URL"
// // // //                                 value={uploadData.url}
// // // //                                 onChange={(e) => setUploadData({ ...uploadData, url: e.target.value })}
// // // //                             />
// // // //                         </Form.Group>
// // // //                     </Modal.Body>
// // // //                     <Modal.Footer>
// // // //                         <Button variant="secondary" onClick={() => setShowUploadModal(false)}>
// // // //                             Close
// // // //                         </Button>
// // // //                         <Button variant="primary" onClick={handleUploadSubmit}>
// // // //                             Submit
// // // //                         </Button>
// // // //                     </Modal.Footer>
// // // //                 </Modal>

// // // //             </div>
// // // //         </>
// // // //     );
// // // // };

// // // // export default OrdersData;



// // // // // import React, { useState, useEffect } from "react";
// // // // // import { Link } from "react-router-dom";
// // // // // import Swal from "sweetalert2";
// // // // // import db from "./Firebase";
// // // // // import {
// // // // //     collection,
// // // // //     doc,
// // // // //     getDoc,
// // // // //     updateDoc,
// // // // //     query,
// // // // //     where,
// // // // //     getDocs,
// // // // //     addDoc,
// // // // //     orderBy,
// // // // // } from "firebase/firestore";
// // // // // import Moment from "moment";
// // // // // import { Button, Form, Modal } from "react-bootstrap";
// // // // // import * as XLSX from "xlsx";

// // // // // const OrdersData = () => {
// // // // //     const [orders, setOrders] = useState([]);
// // // // //     const [showModal, setShowModal] = useState(false);
// // // // //     const [uploadData, setUploadData] = useState({
// // // // //         orderId: "",
// // // // //         phoneNo: "",
// // // // //         itemName: "",
// // // // //         url: "",
// // // // //     });
// // // // //     const [filteredOrders, setFilteredOrders] = useState([]);
// // // // //     const [searchQuery, setSearchQuery] = useState("");
// // // // //     const [visibleSteps, setVisibleSteps] = useState({}); // 👈 show/hide tracker

// // // // //     useEffect(() => {
// // // // //         fetchOrders();
// // // // //     }, []);

// // // // //     const fetchOrders = async () => {
// // // // //         try {
// // // // //             const ordersRef = collection(db, "nv_orders_data");
// // // // //             const q = query(ordersRef, orderBy("order_date", "desc"));
// // // // //             const querySnapshot = await getDocs(q);
// // // // //             const ordersData = [];
// // // // //             querySnapshot.forEach((docSnap) => {
// // // // //                 ordersData.push({ id: docSnap.id, ...docSnap.data() });
// // // // //             });
// // // // //             setOrders(ordersData);
// // // // //             setFilteredOrders(ordersData);
// // // // //         } catch (error) {
// // // // //             console.error("Error fetching orders:", error);
// // // // //         }
// // // // //     };

// // // // //     const handleSearch = (event) => {
// // // // //         const query = event.target.value;
// // // // //         setSearchQuery(query);
// // // // //         if (query.trim() === "") setFilteredOrders(orders);
// // // // //         else
// // // // //             setFilteredOrders(
// // // // //                 orders.filter((order) => order.phone_no.includes(query.trim()))
// // // // //             );
// // // // //     };

// // // // //     const exportToExcel = () => {
// // // // //         const formattedData = [];
// // // // //         filteredOrders.forEach((order) => {
// // // // //             order.items.forEach((item) => {
// // // // //                 formattedData.push({
// // // // //                     "Order ID": order.id,
// // // // //                     "Full Name": order.full_name,
// // // // //                     "Phone No": order.phone_no,
// // // // //                     "Business Name": order.business_name,
// // // // //                     "Order Date": Moment(order.order_date.toDate()).format(
// // // // //                         "DD/MM/YY, h:mm a"
// // // // //                     ),
// // // // //                     Status: order.status,
// // // // //                     "Total Amount": order.final_total,
// // // // //                     "Item Name": item.name,
// // // // //                     "Item Price": `${item.membership_price}`,
// // // // //                     "Item Type": item.type,
// // // // //                     "Process Status": item.process
// // // // //                         .map((step) => `${step.step}: ${step.status}`)
// // // // //                         .join(" | "),
// // // // //                 });
// // // // //             });
// // // // //         });
// // // // //         const ws = XLSX.utils.json_to_sheet(formattedData);
// // // // //         const wb = XLSX.utils.book_new();
// // // // //         XLSX.utils.book_append_sheet(wb, ws, "Orders");
// // // // //         XLSX.writeFile(wb, "OrdersData.xlsx");
// // // // //     };

// // // // //     const toggleSteps = (orderId, itemIndex) => {
// // // // //         const key = `${orderId}-${itemIndex}`;
// // // // //         setVisibleSteps((prev) => ({
// // // // //             ...prev,
// // // // //             [key]: !prev[key],
// // // // //         }));
// // // // //     };

// // // // //     // ======= WhatsApp templates =======
// // // // //     const sendCallNotConnected = (phone, name) => {
// // // // //         const raw = JSON.stringify({
// // // // //             messaging_product: "whatsapp",
// // // // //             to: `91${phone}`,
// // // // //             type: "template",
// // // // //             template: {
// // // // //                 name: "studeio_design_call",
// // // // //                 language: { code: "en_US", policy: "deterministic" },
// // // // //                 components: [{ type: "body", parameters: [{ type: "text", text: name }] }],
// // // // //             },
// // // // //         });
// // // // //         fetch("https://graph.facebook.com/v14.0/104489945783566/messages", {
// // // // //             method: "POST",
// // // // //             headers: {
// // // // //                 Authorization:
// // // // //                     "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR",
// // // // //                 "Content-Type": "application/json",
// // // // //             },
// // // // //             body: raw,
// // // // //         });
// // // // //     };

// // // // //     const sendDesignReady = (phone, name) => {
// // // // //         const raw = JSON.stringify({
// // // // //             messaging_product: "whatsapp",
// // // // //             to: `91${phone}`,
// // // // //             type: "template",
// // // // //             template: {
// // // // //                 name: "studio_design_ready",
// // // // //                 language: { code: "en_US", policy: "deterministic" },
// // // // //                 components: [{ type: "body", parameters: [{ type: "text", text: name }] }],
// // // // //             },
// // // // //         });
// // // // //         fetch("https://graph.facebook.com/v14.0/104489945783566/messages", {
// // // // //             method: "POST",
// // // // //             headers: {
// // // // //                 Authorization:
// // // // //                     "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR",
// // // // //                 "Content-Type": "application/json",
// // // // //             },
// // // // //             body: raw,
// // // // //         });
// // // // //     };

// // // // //     const sendDelivery = (phone, name) => {
// // // // //         const raw = JSON.stringify({
// // // // //             messaging_product: "whatsapp",
// // // // //             to: `91${phone}`,
// // // // //             type: "template",
// // // // //             template: {
// // // // //                 name: "studio_design_completed",
// // // // //                 language: { code: "en_US", policy: "deterministic" },
// // // // //                 components: [{ type: "body", parameters: [{ type: "text", text: name }] }],
// // // // //             },
// // // // //         });
// // // // //         fetch("https://graph.facebook.com/v14.0/104489945783566/messages", {
// // // // //             method: "POST",
// // // // //             headers: {
// // // // //                 Authorization:
// // // // //                     "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR",
// // // // //                 "Content-Type": "application/json",
// // // // //             },
// // // // //             body: raw,
// // // // //         });
// // // // //     };

// // // // //     const handleStatusChange = async (
// // // // //         fullname,
// // // // //         phone,
// // // // //         orderId,
// // // // //         itemIndex,
// // // // //         processIndex,
// // // // //         newStatus
// // // // //     ) => {
// // // // //         const orderRef = doc(db, "nv_orders_data", orderId);
// // // // //         const orderSnap = await getDoc(orderRef);
// // // // //         if (!orderSnap.exists()) return;

// // // // //         let updatedOrder = orderSnap.data();
// // // // //         let stepName = updatedOrder.items[itemIndex].process[processIndex].step;

// // // // //         if (stepName === "Youvati Call" && newStatus === "completed") {
// // // // //             Swal.fire({
// // // // //                 title: "Call Status",
// // // // //                 text: "Was the call connected?",
// // // // //                 icon: "question",
// // // // //                 showCancelButton: true,
// // // // //                 confirmButtonText: "Call Connected",
// // // // //                 cancelButtonText: "Call Not Connected",
// // // // //                 reverseButtons: true,
// // // // //             }).then((result) => {
// // // // //                 if (result.isConfirmed) {
// // // // //                     sendDesignReady(phone, fullname);
// // // // //                     updateOrderStatus(orderRef, updatedOrder, itemIndex, processIndex, "completed");
// // // // //                 } else {
// // // // //                     sendCallNotConnected(phone, fullname);
// // // // //                     Swal.fire("Call Not Connected", "The status remains pending.", "info");
// // // // //                 }
// // // // //             });
// // // // //         } else if (stepName === "Delivery" && newStatus === "completed") {
// // // // //             sendDelivery(phone, fullname);
// // // // //             updateOrderStatus(orderRef, updatedOrder, itemIndex, processIndex, newStatus);
// // // // //         } else {
// // // // //             updateOrderStatus(orderRef, updatedOrder, itemIndex, processIndex, newStatus);
// // // // //         }
// // // // //     };

// // // // //     const updateOrderStatus = async (orderRef, updatedOrder, itemIndex, processIndex, newStatus) => {
// // // // //         updatedOrder.items[itemIndex].process[processIndex].status = newStatus;
// // // // //         updatedOrder.items[itemIndex].process[processIndex].isActive = newStatus === "completed";
// // // // //         await updateDoc(orderRef, { items: updatedOrder.items });
// // // // //         setOrders((prev) =>
// // // // //             prev.map((o) => (o.id === orderRef.id ? { ...o, items: updatedOrder.items } : o))
// // // // //         );
// // // // //         setFilteredOrders((prev) =>
// // // // //             prev.map((o) => (o.id === orderRef.id ? { ...o, items: updatedOrder.items } : o))
// // // // //         );
// // // // //     };

// // // // //     const openUploadModal = (orderId, phoneNo, itemName) => {
// // // // //         setUploadData({ orderId, phoneNo, itemName, url: "" });
// // // // //         setShowModal(true);
// // // // //     };

// // // // //     const handleUploadSubmit = async () => {
// // // // //         if (!uploadData.url) {
// // // // //             alert("Please enter a valid URL");
// // // // //             return;
// // // // //         }
// // // // //         try {
// // // // //             await addDoc(collection(db, "nv_downloads"), {
// // // // //                 category: "Design",
// // // // //                 created_date: new Date(),
// // // // //                 date: new Date(),
// // // // //                 image: "",
// // // // //                 phone_no: uploadData.phoneNo,
// // // // //                 selected: false,
// // // // //                 title: uploadData.itemName,
// // // // //                 url: uploadData.url,
// // // // //             });

// // // // //             const querySnapshot = await getDocs(
// // // // //                 query(collection(db, "personal_details"), where("phone_no", "==", uploadData.phoneNo))
// // // // //             );
// // // // //             if (querySnapshot.empty) {
// // // // //                 alert("User not found!");
// // // // //                 return;
// // // // //             }

// // // // //             let username = "";
// // // // //             querySnapshot.forEach((doc) => (username = doc.data().username));

// // // // //             await addDoc(collection(db, "nv_notifications"), {
// // // // //                 actions: false,
// // // // //                 category: "Grow",
// // // // //                 created_at: new Date(),
// // // // //                 image: "",
// // // // //                 requested_phone_no: uploadData.phoneNo,
// // // // //                 requested_user: username,
// // // // //                 seen_by: [],
// // // // //                 status: "1",
// // // // //                 timestamp: new Date(),
// // // // //                 title: `Your ${uploadData.itemName} is ready to download`,
// // // // //                 type: "private",
// // // // //                 user_id: username,
// // // // //                 id: new Date().getTime() + new Date().getMilliseconds(),
// // // // //             });

// // // // //             setShowModal(false);
// // // // //             alert("File uploaded successfully!");
// // // // //         } catch (error) {
// // // // //             console.error("Error uploading file:", error);
// // // // //             alert("Error uploading file");
// // // // //         }
// // // // //     };

// // // // //     return (
// // // // //         <>
// // // // //             <div
// // // // //                 className="p-2"
// // // // //                 style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}
// // // // //             >
// // // // //                 <Link to="/">
// // // // //                     <img
// // // // //                         src="/images/menubutton.png"
// // // // //                         className="menu-toggle"
// // // // //                         alt="Menu"
// // // // //                         style={{ height: "2rem" }}
// // // // //                     />
// // // // //                 </Link>
// // // // //             </div>

// // // // //             <div className="p-3">
// // // // //                 <div className="card-header pb-0 px-3 d-flex align-items-center gap-3">
// // // // //                     <h4 className="mb-2">Orders List</h4>
// // // // //                     <Form.Control
// // // // //                         type="text"
// // // // //                         placeholder="Search by Phone Number..."
// // // // //                         value={searchQuery}
// // // // //                         onChange={handleSearch}
// // // // //                         style={{ width: "300px" }}
// // // // //                     />
// // // // //                     <Button variant="success" onClick={exportToExcel}>
// // // // //                         Download Excel
// // // // //                     </Button>
// // // // //                 </div>

// // // // //                 <div className="table-responsive fix-width scroll-inner mt-3">
// // // // //                     <table className="table table-bordered table-hover">
// // // // //                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// // // // //                             <tr>
// // // // //                                 <th>Order ID</th>
// // // // //                                 <th>Full Name</th>
// // // // //                                 <th>Business Name</th>
// // // // //                                 <th>Item Name</th>
// // // // //                                 <th>Item Price</th>
// // // // //                                 <th>Order Date</th>
// // // // //                                 <th>Process Steps</th>
// // // // //                             </tr>
// // // // //                         </thead>
// // // // //                         <tbody>
// // // // //                             {filteredOrders.map((order) =>
// // // // //                                 order.items.map((item, itemIndex) => {
// // // // //                                     const key = `${order.id}-${itemIndex}`;
// // // // //                                     return (
// // // // //                                         <React.Fragment key={key}>
// // // // //                                             <tr style={{ background: order.status === "Completed" ? "palegreen" : "" }}>
// // // // //                                                 <td>
// // // // //                                                     {order.id || "N/A"} <p>Total Amount : {order.final_total || "N/A"}</p>
// // // // //                                                 </td>
// // // // //                                                 <td>
// // // // //                                                     {order.full_name || "N/A"} <p>{order.phone_no || "N/A"}</p>
// // // // //                                                 </td>
// // // // //                                                 <td>{order.business_name}</td>
// // // // //                                                 <td>{item.name}</td>
// // // // //                                                 <td>{item.membership_price}</td>
// // // // //                                                 <td>{Moment(order.order_date.toDate()).format("YYYY-MM-DD HH:mm")}</td>
// // // // //                                                 <td>
// // // // //                                                     <Button
// // // // //                                                         variant="info"
// // // // //                                                         size="sm"
// // // // //                                                         onClick={() => toggleSteps(order.id, itemIndex)}
// // // // //                                                     >
// // // // //                                                         {visibleSteps[key] ? "Hide Steps" : "View Steps"}
// // // // //                                                     </Button>
// // // // //                                                 </td>
// // // // //                                             </tr>

// // // // //                                             {visibleSteps[key] && (
// // // // //                                                 <tr>
// // // // //                                                     <td colSpan="7" style={{ background: "#fafafa" }}>
// // // // //                                                         {item.process.map((step, processIndex) => (
// // // // //                                                             <div
// // // // //                                                                 key={`${key}-${processIndex}`}
// // // // //                                                                 className="d-flex align-items-center justify-content-between mb-2"
// // // // //                                                             >
// // // // //                                                                 <strong>{step.step}:</strong>
// // // // //                                                                 <div>
// // // // //                                                                     {step.step === "Delivery" && (
// // // // //                                                                         <Button
// // // // //                                                                             variant="primary"
// // // // //                                                                             size="sm"
// // // // //                                                                             className="ms-2"
// // // // //                                                                             onClick={() =>
// // // // //                                                                                 openUploadModal(order.id, order.phone_no, item.name)
// // // // //                                                                             }
// // // // //                                                                             disabled={step.status === "completed"}
// // // // //                                                                         >
// // // // //                                                                             Upload File
// // // // //                                                                         </Button>
// // // // //                                                                     )}
// // // // //                                                                     <Button
// // // // //                                                                         variant={
// // // // //                                                                             step.status === "completed" ? "success" : "danger"
// // // // //                                                                         }
// // // // //                                                                         size="sm"
// // // // //                                                                         onClick={() =>
// // // // //                                                                             handleStatusChange(
// // // // //                                                                                 order.full_name,
// // // // //                                                                                 order.phone_no,
// // // // //                                                                                 order.id,
// // // // //                                                                                 itemIndex,
// // // // //                                                                                 processIndex,
// // // // //                                                                                 step.status === "pending"
// // // // //                                                                                     ? "completed"
// // // // //                                                                                     : "pending"
// // // // //                                                                             )
// // // // //                                                                         }
// // // // //                                                                         disabled={step.status === "completed"}
// // // // //                                                                     >
// // // // //                                                                         {step.status === "pending"
// // // // //                                                                             ? "Mark Completed"
// // // // //                                                                             : "Completed"}
// // // // //                                                                     </Button>
// // // // //                                                                 </div>
// // // // //                                                             </div>
// // // // //                                                         ))}
// // // // //                                                     </td>
// // // // //                                                 </tr>
// // // // //                                             )}
// // // // //                                         </React.Fragment>
// // // // //                                     );
// // // // //                                 })
// // // // //                             )}
// // // // //                         </tbody>
// // // // //                     </table>
// // // // //                 </div>

// // // // //                 {/* Upload File Modal */}
// // // // //                 <Modal show={showModal} onHide={() => setShowModal(false)}>
// // // // //                     <Modal.Header closeButton>
// // // // //                         <Modal.Title>Upload File URL</Modal.Title>
// // // // //                     </Modal.Header>
// // // // //                     <Modal.Body>
// // // // //                         <Form.Group className="mb-3">
// // // // //                             <Form.Label>File URL</Form.Label>
// // // // //                             <Form.Control
// // // // //                                 type="text"
// // // // //                                 placeholder="Enter file URL"
// // // // //                                 value={uploadData.url}
// // // // //                                 onChange={(e) =>
// // // // //                                     setUploadData({ ...uploadData, url: e.target.value })
// // // // //                                 }
// // // // //                             />
// // // // //                         </Form.Group>
// // // // //                     </Modal.Body>
// // // // //                     <Modal.Footer>
// // // // //                         <Button variant="secondary" onClick={() => setShowModal(false)}>
// // // // //                             Close
// // // // //                         </Button>
// // // // //                         <Button variant="primary" onClick={handleUploadSubmit}>
// // // // //                             Submit
// // // // //                         </Button>
// // // // //                     </Modal.Footer>
// // // // //                 </Modal>
// // // // //             </div>
// // // // //         </>
// // // // //     );
// // // // // };

// // // // // export default OrdersData;


// // // // // // import React, { useState, useEffect } from "react";



// // // // // // import { useNavigate, Link, useParams } from 'react-router-dom';
// // // // // // import Swal from 'sweetalert2'
// // // // // // import db from "./Firebase";
// // // // // // import { storage } from './Firebase';
// // // // // // import { collection, doc, getDoc, updateDoc, query, where, getDocs, addDoc, Timestamp, orderBy } from "firebase/firestore";

// // // // // // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // // // // // import Moment from 'moment';
// // // // // // import { extendMoment } from 'moment-range';
// // // // // // import { Accordion, Button, Table, Container, Modal, Form } from "react-bootstrap";
// // // // // // import * as XLSX from "xlsx"; // Import XLSX for Excel export

// // // // // // const OrdersData = () => {
// // // // // //     const [orders, setOrders] = useState([]);
// // // // // //     const [showModal, setShowModal] = useState(false);
// // // // // //     const [uploadData, setUploadData] = useState({ orderId: "", phoneNo: "", itemName: "", url: "" });
// // // // // //     const [filteredOrders, setFilteredOrders] = useState([]); // Stores filtered results
// // // // // //     const [searchQuery, setSearchQuery] = useState("");

// // // // // //     const [activeAccordions, setActiveAccordions] = useState({});

// // // // // //     useEffect(() => {
// // // // // //         fetchOrders();
// // // // // //     }, []);


// // // // // //     const toggleAccordion = (orderId, itemIndex) => {
// // // // // //         const key = `${orderId}-${itemIndex}`;
// // // // // //         setActiveAccordions((prev) =>
// // // // // //             Object.keys(prev).length === 1 && prev[key]
// // // // // //                 ? {} // close all
// // // // // //                 : { [key]: !prev[key] } // open one
// // // // // //         );
// // // // // //     };



// // // // // //     const fetchOrders = async () => {
// // // // // //         try {
// // // // // //             // ✅ Query orders ordered by order_date descending
// // // // // //             const ordersRef = collection(db, "nv_orders_data");
// // // // // //             const q = query(ordersRef, orderBy("order_date", "desc"));

// // // // // //             const querySnapshot = await getDocs(q);
// // // // // //             const ordersData = [];

// // // // // //             querySnapshot.forEach((docSnap) => {
// // // // // //                 ordersData.push({
// // // // // //                     id: docSnap.id,
// // // // // //                     ...docSnap.data(),
// // // // // //                 });
// // // // // //             });

// // // // // //             setOrders(ordersData);
// // // // // //             setFilteredOrders(ordersData);
// // // // // //         } catch (error) {
// // // // // //             console.error("Error fetching orders:", error);
// // // // // //         }
// // // // // //     };


// // // // // //     // Handle search functionality
// // // // // //     const handleSearch = (event) => {
// // // // // //         const query = event.target.value;
// // // // // //         setSearchQuery(query);

// // // // // //         if (query.trim() === "") {
// // // // // //             setFilteredOrders(orders);
// // // // // //         } else {
// // // // // //             const filtered = orders.filter((order) =>
// // // // // //                 order.phone_no.includes(query.trim())
// // // // // //             );
// // // // // //             setFilteredOrders(filtered);
// // // // // //         }
// // // // // //     };



// // // // // //     const exportToExcel = () => {
// // // // // //         const formattedData = [];

// // // // // //         // Loop through each order and extract each item as a row
// // // // // //         filteredOrders.forEach((order) => {
// // // // // //             order.items.forEach((item, itemIndex) => {
// // // // // //                 formattedData.push({
// // // // // //                     "Order ID": order.id,
// // // // // //                     "Full Name": order.full_name,
// // // // // //                     "Phone No": order.phone_no,
// // // // // //                     "Business Name": order.business_name,
// // // // // //                     "Order Date": Moment(order.order_date.toDate()).format("DD/MM/YY, h:mm a"),
// // // // // //                     "Status": order.status,
// // // // // //                     "Total Amount": order.final_total,
// // // // // //                     "Item Name": item.name, // Include item details
// // // // // //                     "Item Price": `${item.membership_price}`,
// // // // // //                     "Item Type": item.type,
// // // // // //                     "Process Status": item.process.map(step => `${step.step}: ${step.status}`).join(" | ") // Combine all steps
// // // // // //                 });
// // // // // //             });
// // // // // //         });

// // // // // //         // Convert to worksheet and create Excel file
// // // // // //         const ws = XLSX.utils.json_to_sheet(formattedData);
// // // // // //         const wb = XLSX.utils.book_new();
// // // // // //         XLSX.utils.book_append_sheet(wb, ws, "Orders");
// // // // // //         XLSX.writeFile(wb, "OrdersData.xlsx");
// // // // // //     };



// // // // // //     // const handleStatusChange = async (orderId, itemIndex, processIndex, newStatus) => {
// // // // // //     //     const orderRef = doc(db, "nv_orders_data", orderId);
// // // // // //     //     const orderSnap = await getDoc(orderRef);

// // // // // //     //     if (orderSnap.exists()) {
// // // // // //     //         let updatedOrder = orderSnap.data();
// // // // // //     //         let stepName = updatedOrder.items[itemIndex].process[processIndex].step; // Get step name

// // // // // //     //         // Update process status & isActive
// // // // // //     //         updatedOrder.items[itemIndex].process[processIndex].status = newStatus;
// // // // // //     //         updatedOrder.items[itemIndex].process[processIndex].isActive = newStatus === "completed";

// // // // // //     //         // ✅ Console log the action
// // // // // //     //         console.log(`${stepName} ${newStatus === "completed" ? "completed" : "marked as pending"}`);

// // // // // //     //         // Update Firestore
// // // // // //     //         await updateDoc(orderRef, { items: updatedOrder.items });

// // // // // //     //         // Update UI state immediately
// // // // // //     //         setOrders((prevOrders) =>
// // // // // //     //             prevOrders.map((order) =>
// // // // // //     //                 order.id === orderId ? { ...order, items: updatedOrder.items } : order
// // // // // //     //             )
// // // // // //     //         );

// // // // // //     //         setFilteredOrders((prevOrders) =>
// // // // // //     //             prevOrders.map((order) =>
// // // // // //     //                 // order.id === orderId ? { ...order, items: updatedOrder.items } : order
// // // // // //     //                 order.id === orderId ? { ...order, items: updatedOrder.items, status: updatedOrder.status } : order
// // // // // //     //             )
// // // // // //     //         );
// // // // // //     //     }
// // // // // //     // };


// // // // // //     const sendCallNotConnected = (phone, name) => {

// // // // // //         var myHeaders = new Headers();
// // // // // //         myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
// // // // // //         myHeaders.append("Content-Type", "application/json");

// // // // // //         var raw = JSON.stringify({
// // // // // //             "messaging_product": "whatsapp",
// // // // // //             "to": `91${phone}`,
// // // // // //             "type": "template",
// // // // // //             "template": {
// // // // // //                 "name": "studeio_design_call",
// // // // // //                 "language": {
// // // // // //                     "code": "en_US",
// // // // // //                     "policy": "deterministic"
// // // // // //                 },
// // // // // //                 "components": [
// // // // // //                     {
// // // // // //                         "type": "body",
// // // // // //                         "parameters": [
// // // // // //                             {
// // // // // //                                 "type": "text",
// // // // // //                                 "text": name
// // // // // //                             }
// // // // // //                         ]
// // // // // //                     }
// // // // // //                 ]
// // // // // //             }
// // // // // //         });

// // // // // //         var requestOptions = {
// // // // // //             method: 'POST',
// // // // // //             headers: myHeaders,
// // // // // //             body: raw,
// // // // // //             redirect: 'follow'
// // // // // //         };

// // // // // //         fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
// // // // // //             .then(response => response.text())
// // // // // //             .then(result => console.log(result))
// // // // // //             .catch(error => console.log('error', error));

// // // // // //     }



// // // // // //     const sendDesignReady = (phone, name) => {

// // // // // //         var myHeaders = new Headers();
// // // // // //         myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
// // // // // //         myHeaders.append("Content-Type", "application/json");

// // // // // //         var raw = JSON.stringify({
// // // // // //             "messaging_product": "whatsapp",
// // // // // //             "to": `91${phone}`,
// // // // // //             "type": "template",
// // // // // //             "template": {
// // // // // //                 "name": "studio_design_ready",
// // // // // //                 "language": {
// // // // // //                     "code": "en_US",
// // // // // //                     "policy": "deterministic"
// // // // // //                 },
// // // // // //                 "components": [
// // // // // //                     {
// // // // // //                         "type": "body",
// // // // // //                         "parameters": [
// // // // // //                             {
// // // // // //                                 "type": "text",
// // // // // //                                 "text": name
// // // // // //                             }
// // // // // //                         ]
// // // // // //                     }
// // // // // //                 ]
// // // // // //             }
// // // // // //         });

// // // // // //         var requestOptions = {
// // // // // //             method: 'POST',
// // // // // //             headers: myHeaders,
// // // // // //             body: raw,
// // // // // //             redirect: 'follow'
// // // // // //         };

// // // // // //         fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
// // // // // //             .then(response => response.text())
// // // // // //             .then(result => console.log(result))
// // // // // //             .catch(error => console.log('error', error));

// // // // // //     }

// // // // // //     const sendDelivery = (phone, name) => {

// // // // // //         var myHeaders = new Headers();
// // // // // //         myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
// // // // // //         myHeaders.append("Content-Type", "application/json");

// // // // // //         var raw = JSON.stringify({
// // // // // //             "messaging_product": "whatsapp",
// // // // // //             "to": `91${phone}`,
// // // // // //             "type": "template",
// // // // // //             "template": {
// // // // // //                 "name": "studio_design_completed",
// // // // // //                 "language": {
// // // // // //                     "code": "en_US",
// // // // // //                     "policy": "deterministic"
// // // // // //                 },
// // // // // //                 "components": [
// // // // // //                     {
// // // // // //                         "type": "body",
// // // // // //                         "parameters": [
// // // // // //                             {
// // // // // //                                 "type": "text",
// // // // // //                                 "text": name
// // // // // //                             }
// // // // // //                         ]
// // // // // //                     }
// // // // // //                 ]
// // // // // //             }
// // // // // //         });

// // // // // //         var requestOptions = {
// // // // // //             method: 'POST',
// // // // // //             headers: myHeaders,
// // // // // //             body: raw,
// // // // // //             redirect: 'follow'
// // // // // //         };

// // // // // //         fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
// // // // // //             .then(response => response.text())
// // // // // //             .then(result => console.log(result))
// // // // // //             .catch(error => console.log('error', error));

// // // // // //     }

// // // // // //     const handleStatusChange = async (fullname, phone, orderId, itemIndex, processIndex, newStatus) => {
// // // // // //         // console.log(fullname)
// // // // // //         // console.log(phone)
// // // // // //         const orderRef = doc(db, "nv_orders_data", orderId);
// // // // // //         const orderSnap = await getDoc(orderRef);

// // // // // //         if (orderSnap.exists()) {
// // // // // //             let updatedOrder = orderSnap.data();
// // // // // //             let stepName = updatedOrder.items[itemIndex].process[processIndex].step; // Get step name

// // // // // //             // ✅ If step is "Youvati Call" and marking as completed, show popup
// // // // // //             if (stepName === "Youvati Call" && newStatus === "completed") {
// // // // // //                 Swal.fire({
// // // // // //                     title: "Call Status",
// // // // // //                     text: "Was the call connected?",
// // // // // //                     icon: "question",
// // // // // //                     showCancelButton: true,
// // // // // //                     confirmButtonText: "Call Connected",
// // // // // //                     cancelButtonText: "Call Not Connected",
// // // // // //                     reverseButtons: true
// // // // // //                 }).then((result) => {
// // // // // //                     if (result.isConfirmed) {
// // // // // //                         sendDesignReady(phone, fullname)
// // // // // //                         // ✅ If call connected, proceed to mark as completed
// // // // // //                         updateOrderStatus(orderRef, updatedOrder, itemIndex, processIndex, "completed");
// // // // // //                     } else {
// // // // // //                         // ❌ If call not connected, show alert and do not update status
// // // // // //                         sendCallNotConnected(phone, fullname);
// // // // // //                         Swal.fire("Call Not Connected", "The status remains pending.", "info");
// // // // // //                     }
// // // // // //                 });
// // // // // //             } else if (stepName === "Delivery" && newStatus === "completed") {
// // // // // //                 sendDelivery(phone, fullname)
// // // // // //                 // ✅ If not "Youvati Call", update status normally
// // // // // //                 updateOrderStatus(orderRef, updatedOrder, itemIndex, processIndex, newStatus);
// // // // // //             }
// // // // // //             else {

// // // // // //                 // ✅ If not "Youvati Call", update status normally
// // // // // //                 updateOrderStatus(orderRef, updatedOrder, itemIndex, processIndex, newStatus);
// // // // // //             }
// // // // // //         }
// // // // // //     };


// // // // // //     // ✅ Function to update Firestore and UI state
// // // // // //     const updateOrderStatus = async (orderRef, updatedOrder, itemIndex, processIndex, newStatus) => {
// // // // // //         updatedOrder.items[itemIndex].process[processIndex].status = newStatus;
// // // // // //         updatedOrder.items[itemIndex].process[processIndex].isActive = newStatus === "completed";

// // // // // //         // ✅ Console log action
// // // // // //         console.log(`${updatedOrder.items[itemIndex].process[processIndex].step} ${newStatus}`);

// // // // // //         // ✅ Update Firestore
// // // // // //         await updateDoc(orderRef, { items: updatedOrder.items });

// // // // // //         // ✅ Update UI state immediately
// // // // // //         setOrders((prevOrders) =>
// // // // // //             prevOrders.map((order) =>
// // // // // //                 order.id === orderRef.id ? { ...order, items: updatedOrder.items } : order
// // // // // //             )
// // // // // //         );

// // // // // //         setFilteredOrders((prevOrders) =>
// // // // // //             prevOrders.map((order) =>
// // // // // //                 order.id === orderRef.id ? { ...order, items: updatedOrder.items } : order
// // // // // //             )
// // // // // //         );
// // // // // //     };



// // // // // //     // const handleStatusChange = async (orderId, itemIndex, processIndex, newStatus) => {
// // // // // //     //     const orderRef = doc(db, "nv_orders_data", orderId);
// // // // // //     //     const orderSnap = await getDoc(orderRef);

// // // // // //     //     if (orderSnap.exists()) {
// // // // // //     //         let updatedOrder = orderSnap.data();

// // // // // //     //         // Update process status & isActive
// // // // // //     //         updatedOrder.items[itemIndex].process[processIndex].status = newStatus;
// // // // // //     //         updatedOrder.items[itemIndex].process[processIndex].isActive = newStatus === "completed";

// // // // // //     //         // // Check if the updated step is "Delivery" and mark the entire order as completed
// // // // // //     //         // if (updatedOrder.items[itemIndex].process[processIndex].step === "Delivery" && newStatus === "completed") {
// // // // // //     //         //     updatedOrder.status = "Completed"; // Update the main status
// // // // // //     //         // }

// // // // // //     //         // Update Firestore
// // // // // //     //         await updateDoc(orderRef, {
// // // // // //     //             items: updatedOrder.items,
// // // // // //     //             // status: updatedOrder.status // Save updated status at the main level
// // // // // //     //         });

// // // // // //     //         // Update UI state
// // // // // //     //         setOrders((prevOrders) =>
// // // // // //     //             prevOrders.map((order) =>
// // // // // //     //                 // order.id === orderId ? { ...order, items: updatedOrder.items } : order
// // // // // //     //                 order.id === orderId ? { ...order, items: updatedOrder.items, status: updatedOrder.status } : order
// // // // // //     //             )
// // // // // //     //         );

// // // // // //     //     }
// // // // // //     // };


// // // // // //     // Open Upload File Modal
// // // // // //     const openUploadModal = (orderId, phoneNo, itemName) => {
// // // // // //         setUploadData({ orderId, phoneNo, itemName, url: "" });
// // // // // //         setShowModal(true);
// // // // // //     };

// // // // // //     // Handle Upload Submission
// // // // // //     const handleUploadSubmit = async () => {
// // // // // //         if (!uploadData.url) {
// // // // // //             alert("Please enter a valid URL");
// // // // // //             return;
// // // // // //         }

// // // // // //         try {
// // // // // //             await addDoc(collection(db, "nv_downloads"), {
// // // // // //                 category: "Design",
// // // // // //                 created_date: new Date(),
// // // // // //                 date: new Date(),
// // // // // //                 image: "",
// // // // // //                 phone_no: uploadData.phoneNo,
// // // // // //                 selected: false,
// // // // // //                 title: uploadData.itemName,
// // // // // //                 url: uploadData.url // Store URL as an array
// // // // // //             });
// // // // // //             // 1️⃣ Fetch username from personal_details where phone_no = uploadData.phoneNo
// // // // // //             const querySnapshot = await getDocs(
// // // // // //                 query(collection(db, "personal_details"), where("phone_no", "==", uploadData.phoneNo))
// // // // // //             );


// // // // // //             if (querySnapshot.empty) {
// // // // // //                 alert("User not found!");
// // // // // //                 return;
// // // // // //             }


// // // // // //             let username = "";
// // // // // //             querySnapshot.forEach((doc) => {
// // // // // //                 username = doc.data().username; // Get username
// // // // // //             });


// // // // // //             // 2️⃣ Now create entry in nv_notifications
// // // // // //             await addDoc(collection(db, "nv_notifications"), {
// // // // // //                 actions: false,
// // // // // //                 category: "Grow",
// // // // // //                 created_at: new Date(),
// // // // // //                 image: "",
// // // // // //                 is_download: "",
// // // // // //                 is_join: "",
// // // // // //                 redirect_page: "",
// // // // // //                 requested_phone_no: uploadData.phoneNo,
// // // // // //                 requested_user: username,
// // // // // //                 seen_by: [],
// // // // // //                 status: "1",
// // // // // //                 timestamp: new Date(),
// // // // // //                 title: `Your ${uploadData.itemName} is ready to download`,
// // // // // //                 type: "private",
// // // // // //                 user_id: username, // ✅ Use username as user_id
// // // // // //                 id: new Date().getTime() + new Date().getMilliseconds()
// // // // // //             });

// // // // // //             setShowModal(false);
// // // // // //             alert("File uploaded successfully!");
// // // // // //         } catch (error) {
// // // // // //             console.error("Error uploading file:", error);
// // // // // //             alert("Error uploading file");
// // // // // //         }
// // // // // //     };

// // // // // //     return (
// // // // // //         <>
// // // // // //             <div className="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
// // // // // //                 <Link to="/">
// // // // // //                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
// // // // // //                 </Link>
// // // // // //             </div>
// // // // // //             <div className="mb-3 d-flex align-items-center gap-3">


// // // // // //             </div>
// // // // // //             <div className="p-3">
// // // // // //                 <div className="card-header pb-0 px-3" style={{ display: "flex" }}>
// // // // // //                     <h4 className="mb-2 mr-4">Orders List</h4>

// // // // // //                     <Form.Control
// // // // // //                         type="text"
// // // // // //                         placeholder="Search by Phone Number..."
// // // // // //                         value={searchQuery}
// // // // // //                         onChange={handleSearch}
// // // // // //                         style={{ width: "300px" }}
// // // // // //                     />

// // // // // //                     <div className="ml-4">
// // // // // //                         <Button variant="success" onClick={exportToExcel}>
// // // // // //                             Download Excel
// // // // // //                         </Button>
// // // // // //                     </div>
// // // // // //                 </div>
// // // // // //                 <div className="table-responsive fix-width scroll-inner">
// // // // // //                     <table className="table table-bordered table-hover">
// // // // // //                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// // // // // //                             <tr>
// // // // // //                                 <th>Order ID</th>
// // // // // //                                 <th>Full Name</th>
// // // // // //                                 <th>Business Name</th>
// // // // // //                                 <th>Item Name</th>
// // // // // //                                 <th>Item Price</th>
// // // // // //                                 <th>Order Date</th>
// // // // // //                                 <th>Process Steps</th>
// // // // // //                             </tr>
// // // // // //                         </thead>
// // // // // //                         <tbody>
// // // // // //                             {filteredOrders.map((order) =>
// // // // // //                                 order.items.map((item, itemIndex) => (
// // // // // //                                     <tr key={`${order.id}-${itemIndex}`} style={{ background: order.status === "Completed" ? "palegreen" : "" }}>

// // // // // //                                         <td>{order.id || "N/A"} <p>Total Amount : {order.final_total || "N/A"}</p></td>

// // // // // //                                         <td>{order.full_name || "N/A"} <p>{order.phone_no || "N/A"}</p></td>
// // // // // //                                         <td>{order.business_name}</td>
// // // // // //                                         <td>{item.name}</td>
// // // // // //                                         <td>{item.membership_price}</td>
// // // // // //                                         <td>{Moment(order.order_date.toDate()).format("YYYY-MM-DD HH:mm")}</td>
// // // // // //                                         <td>
// // // // // //                                             <Accordion activeKey={activeAccordions[`${order.id}-${itemIndex}`] ? "0" : null}>
// // // // // //                                                 <Accordion.Item eventKey="0">
// // // // // //                                                     <Accordion.Header
// // // // // //                                                         onClick={() => toggleAccordion(order.id, itemIndex)}  // 👈 moved click here
// // // // // //                                                     >
// // // // // //                                                         View Steps
// // // // // //                                                     </Accordion.Header>
// // // // // //                                                     <Accordion.Body>
// // // // // //                                                         {item.process.map((step, processIndex) => (
// // // // // //                                                             <div
// // // // // //                                                                 key={`${order.id}-${itemIndex}-${processIndex}`}
// // // // // //                                                                 className="d-flex align-items-center justify-content-between mb-2"
// // // // // //                                                             >
// // // // // //                                                                 <strong>{step.step}:</strong>
// // // // // //                                                                 <div>
// // // // // //                                                                     {step.step === "Delivery" && (
// // // // // //                                                                         <Button
// // // // // //                                                                             variant="primary"
// // // // // //                                                                             size="sm"
// // // // // //                                                                             className="ms-2"
// // // // // //                                                                             onClick={() =>
// // // // // //                                                                                 openUploadModal(order.id, order.phone_no, item.name)
// // // // // //                                                                             }
// // // // // //                                                                             disabled={step.status === "completed"}
// // // // // //                                                                         >
// // // // // //                                                                             Upload File
// // // // // //                                                                         </Button>
// // // // // //                                                                     )}
// // // // // //                                                                     <Button
// // // // // //                                                                         variant={step.status === "completed" ? "success" : "danger"}
// // // // // //                                                                         size="sm"
// // // // // //                                                                         onClick={() =>
// // // // // //                                                                             handleStatusChange(
// // // // // //                                                                                 order.full_name,
// // // // // //                                                                                 order.phone_no,
// // // // // //                                                                                 order.id,
// // // // // //                                                                                 itemIndex,
// // // // // //                                                                                 processIndex,
// // // // // //                                                                                 step.status === "pending" ? "completed" : "pending"
// // // // // //                                                                             )
// // // // // //                                                                         }
// // // // // //                                                                         disabled={step.status === "completed"}
// // // // // //                                                                     >
// // // // // //                                                                         {step.status === "pending" ? "Mark Completed" : "Completed"}
// // // // // //                                                                     </Button>
// // // // // //                                                                 </div>
// // // // // //                                                             </div>
// // // // // //                                                         ))}
// // // // // //                                                     </Accordion.Body>
// // // // // //                                                 </Accordion.Item>
// // // // // //                                             </Accordion>

// // // // // //                                         </td>

// // // // // //                                     </tr>
// // // // // //                                 ))
// // // // // //                             )}
// // // // // //                         </tbody>
// // // // // //                     </table>
// // // // // //                 </div>

// // // // // //                 {/* Upload File Modal */}
// // // // // //                 <Modal show={showModal} onHide={() => setShowModal(false)}>
// // // // // //                     <Modal.Header closeButton>
// // // // // //                         <Modal.Title>Upload File URL</Modal.Title>
// // // // // //                     </Modal.Header>
// // // // // //                     <Modal.Body>
// // // // // //                         <Form.Group className="mb-3">
// // // // // //                             <Form.Label>File URL</Form.Label>
// // // // // //                             <Form.Control
// // // // // //                                 type="text"
// // // // // //                                 placeholder="Enter file URL"
// // // // // //                                 value={uploadData.url}
// // // // // //                                 onChange={(e) => setUploadData({ ...uploadData, url: e.target.value })}
// // // // // //                             />
// // // // // //                         </Form.Group>
// // // // // //                     </Modal.Body>
// // // // // //                     <Modal.Footer>
// // // // // //                         <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
// // // // // //                         <Button variant="primary" onClick={handleUploadSubmit}>Submit</Button>
// // // // // //                     </Modal.Footer>
// // // // // //                 </Modal>
// // // // // //             </div>
// // // // // //         </>
// // // // // //     );
// // // // // // };

// // // // // // export default OrdersData;











// // // // // // // import React, { useState, useEffect } from "react";


// // // // // // // import { useNavigate, Link, useParams } from 'react-router-dom';
// // // // // // // import Swal from 'sweetalert2'
// // // // // // // import db from "./Firebase";
// // // // // // // import { storage } from './Firebase';
// // // // // // // import { collection, doc, getDoc, updateDoc, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";
// // // // // // // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // // // // // // import Moment from 'moment';
// // // // // // // import { extendMoment } from 'moment-range';
// // // // // // // import { Accordion, Button, Table, Container, Modal, Form } from "react-bootstrap";
// // // // // // // import * as XLSX from "xlsx"; // Import XLSX for Excel export

// // // // // // // const OrdersData = () => {
// // // // // // //     const [orders, setOrders] = useState([]);
// // // // // // //     const [showModal, setShowModal] = useState(false);
// // // // // // //     const [uploadData, setUploadData] = useState({ orderId: "", phoneNo: "", itemName: "", url: "" });
// // // // // // //     const [filteredOrders, setFilteredOrders] = useState([]); // Stores filtered results
// // // // // // //     const [searchQuery, setSearchQuery] = useState(""); // Stores search input

// // // // // // //     useEffect(() => {
// // // // // // //         fetchOrders();
// // // // // // //     }, []);

// // // // // // //     // Fetch all orders from Firestore
// // // // // // //     const fetchOrders = async () => {
// // // // // // //         const ordersRef = collection(db, "nv_orders_data");
// // // // // // //         const querySnapshot = await getDocs(ordersRef);

// // // // // // //         const ordersData = [];
// // // // // // //         querySnapshot.forEach((docSnap) => {
// // // // // // //             ordersData.push({
// // // // // // //                 id: docSnap.id,
// // // // // // //                 ...docSnap.data(),
// // // // // // //             });
// // // // // // //         });

// // // // // // //         setOrders(ordersData);
// // // // // // //         setFilteredOrders(ordersData);
// // // // // // //     };


// // // // // // //     // Handle search functionality
// // // // // // //     const handleSearch = (event) => {
// // // // // // //         const query = event.target.value;
// // // // // // //         setSearchQuery(query);

// // // // // // //         if (query.trim() === "") {
// // // // // // //             setFilteredOrders(orders);
// // // // // // //         } else {
// // // // // // //             const filtered = orders.filter((order) =>
// // // // // // //                 order.phone_no.includes(query.trim())
// // // // // // //             );
// // // // // // //             setFilteredOrders(filtered);
// // // // // // //         }
// // // // // // //     };



// // // // // // //     // // Export data to Excel
// // // // // // //     // const exportToExcel = () => {
// // // // // // //     //     const ws = XLSX.utils.json_to_sheet(
// // // // // // //     //         filteredOrders.map((order) => ({
// // // // // // //     //             "Order ID": order.id,
// // // // // // //     //             "Full Name": order.full_name,
// // // // // // //     //             "Phone No": order.phone_no,
// // // // // // //     //             "Business Name": order.business_name,
// // // // // // //     //             "Order Date": Moment(order.order_date.toDate().toISOString()).format("DD/MM/YY, h:mm a"),
// // // // // // //     //             "Status": order.status,
// // // // // // //     //             "Total Amount": order.final_total,
// // // // // // //     //         }))
// // // // // // //     //     );

// // // // // // //     //     const wb = XLSX.utils.book_new();
// // // // // // //     //     XLSX.utils.book_append_sheet(wb, ws, "Orders");
// // // // // // //     //     XLSX.writeFile(wb, "OrdersData.xlsx");
// // // // // // //     // };


// // // // // // //     const exportToExcel = () => {
// // // // // // //         const formattedData = [];

// // // // // // //         // Loop through each order and extract each item as a row
// // // // // // //         filteredOrders.forEach((order) => {
// // // // // // //             order.items.forEach((item, itemIndex) => {
// // // // // // //                 formattedData.push({
// // // // // // //                     "Order ID": order.id,
// // // // // // //                     "Full Name": order.full_name,
// // // // // // //                     "Phone No": order.phone_no,
// // // // // // //                     "Business Name": order.business_name,
// // // // // // //                     "Order Date": Moment(order.order_date.toDate().toISOString()).format("DD/MM/YY, h:mm a"),
// // // // // // //                     "Status": order.status,
// // // // // // //                     "Total Amount": order.final_total,
// // // // // // //                     "Item Name": item.name, // Include item details
// // // // // // //                     "Item Price": `${item.membership_price}`,
// // // // // // //                     "Item Type": item.type,
// // // // // // //                     "Process Status": item.process.map(step => `${step.step}: ${step.status}`).join(" | ") // Combine all steps
// // // // // // //                 });
// // // // // // //             });
// // // // // // //         });

// // // // // // //         // Convert to worksheet and create Excel file
// // // // // // //         const ws = XLSX.utils.json_to_sheet(formattedData);
// // // // // // //         const wb = XLSX.utils.book_new();
// // // // // // //         XLSX.utils.book_append_sheet(wb, ws, "Orders");
// // // // // // //         XLSX.writeFile(wb, "OrdersData.xlsx");
// // // // // // //     };


// // // // // // //     // // Update process status in Firestore
// // // // // // //     // const handleStatusChange = async (orderId, itemIndex, processIndex, newStatus) => {
// // // // // // //     //     const orderRef = doc(db, "nv_orders_data", orderId);
// // // // // // //     //     const orderSnap = await getDoc(orderRef);

// // // // // // //     //     if (orderSnap.exists()) {
// // // // // // //     //         let updatedOrder = orderSnap.data();

// // // // // // //     //         // Update status & isActive
// // // // // // //     //         updatedOrder.items[itemIndex].process[processIndex].status = newStatus;
// // // // // // //     //         updatedOrder.items[itemIndex].process[processIndex].isActive = newStatus === "completed";

// // // // // // //     //         // Update Firestore
// // // // // // //     //         await updateDoc(orderRef, { items: updatedOrder.items });

// // // // // // //     //         // Update UI state
// // // // // // //     //         setOrders((prevOrders) =>
// // // // // // //     //             prevOrders.map((order) =>
// // // // // // //     //                 order.id === orderId ? { ...order, items: updatedOrder.items } : order
// // // // // // //     //             )
// // // // // // //     //         );
// // // // // // //     //     }
// // // // // // //     // };


// // // // // // //     // const handleStatusChange = async (orderId, itemIndex, processIndex, newStatus) => {
// // // // // // //     //     const orderRef = doc(db, "nv_orders_data", orderId);
// // // // // // //     //     const orderSnap = await getDoc(orderRef);

// // // // // // //     //     if (orderSnap.exists()) {
// // // // // // //     //         let updatedOrder = orderSnap.data();

// // // // // // //     //         // Update process status & isActive
// // // // // // //     //         updatedOrder.items[itemIndex].process[processIndex].status = newStatus;
// // // // // // //     //         updatedOrder.items[itemIndex].process[processIndex].isActive = newStatus === "completed";

// // // // // // //     //         // // Check if the updated step is "Delivery" and mark the entire order as completed
// // // // // // //     //         // if (updatedOrder.items[itemIndex].process[processIndex].step === "Delivery" && newStatus === "completed") {
// // // // // // //     //         //     updatedOrder.status = "Completed"; // Update the main status
// // // // // // //     //         // }

// // // // // // //     //         // Update Firestore
// // // // // // //     //         await updateDoc(orderRef, {
// // // // // // //     //             items: updatedOrder.items,
// // // // // // //     //             // status: updatedOrder.status // Save updated status at the main level
// // // // // // //     //         });

// // // // // // //     //         // Update UI state
// // // // // // //     //         setOrders((prevOrders) =>
// // // // // // //     //             prevOrders.map((order) =>
// // // // // // //     //                 // order.id === orderId ? { ...order, items: updatedOrder.items } : order
// // // // // // //     //                 order.id === orderId ? { ...order, items: updatedOrder.items, status: updatedOrder.status } : order
// // // // // // //     //             )
// // // // // // //     //         );
// // // // // // //     //     }
// // // // // // //     // };

// // // // // // //     const handleStatusChange = async (orderId, itemIndex, processIndex, newStatus) => {
// // // // // // //         const orderRef = doc(db, "nv_orders_data", orderId);
// // // // // // //         const orderSnap = await getDoc(orderRef);

// // // // // // //         if (orderSnap.exists()) {
// // // // // // //             let updatedOrder = orderSnap.data();

// // // // // // //             // Update process status & isActive
// // // // // // //             updatedOrder.items = updatedOrder.items.map((item, i) => {
// // // // // // //                 if (i === itemIndex) {
// // // // // // //                     return {
// // // // // // //                         ...item,
// // // // // // //                         process: item.process.map((step, j) =>
// // // // // // //                             j === processIndex
// // // // // // //                                 ? { ...step, status: newStatus, isActive: newStatus === "completed" }
// // // // // // //                                 : step
// // // // // // //                         ),
// // // // // // //                     };
// // // // // // //                 }
// // // // // // //                 return item;
// // // // // // //             });

// // // // // // //             // Update Firestore
// // // // // // //             await updateDoc(orderRef, { items: updatedOrder.items });

// // // // // // //             // ✅ Update state immediately so UI reflects changes without refresh
// // // // // // //             setOrders((prevOrders) =>
// // // // // // //                 prevOrders.map((order) =>
// // // // // // //                     order.id === orderId ? { ...order, items: updatedOrder.items } : order
// // // // // // //                 )
// // // // // // //             );
// // // // // // //         }
// // // // // // //     };



// // // // // // //     // Open Upload File Modal
// // // // // // //     const openUploadModal = (orderId, phoneNo, itemName) => {
// // // // // // //         setUploadData({ orderId, phoneNo, itemName, url: "" });
// // // // // // //         setShowModal(true);
// // // // // // //     };

// // // // // // //     // Handle Upload Submission
// // // // // // //     // const handleUploadSubmit = async () => {
// // // // // // //     //     if (!uploadData.url) {
// // // // // // //     //         alert("Please enter a valid URL");
// // // // // // //     //         return;
// // // // // // //     //     }

// // // // // // //     //     try {
// // // // // // //     //         await addDoc(collection(db, "nv_downloads"), {
// // // // // // //     //             category: "Design",
// // // // // // //     //             created_date: new Date(),
// // // // // // //     //             date: new Date(),
// // // // // // //     //             image: "",
// // // // // // //     //             phone_no: uploadData.phoneNo,
// // // // // // //     //             selected: false,
// // // // // // //     //             title: uploadData.itemName,
// // // // // // //     //             url: uploadData.url // Store URL as an array
// // // // // // //     //         });

// // // // // // //     //         await addDoc(collection(db, "nv_notifications"), {
// // // // // // //     //             actions: false,
// // // // // // //     //             category: "Design",
// // // // // // //     //             created_at: new Date(),
// // // // // // //     //             image: "",
// // // // // // //     //             is_download: "",
// // // // // // //     //             is_join: "",
// // // // // // //     //             redirect_page: "",
// // // // // // //     //             requested_phone_no: "",
// // // // // // //     //             requested_user: "",
// // // // // // //     //             seen_by: [],
// // // // // // //     //             status: "1",
// // // // // // //     //             timestamp: new Date(),
// // // // // // //     //             title: `Your ${uploadData.itemName} is ready to download  `,
// // // // // // //     //             type: "",
// // // // // // //     //             user_id: "",
// // // // // // //     //             created_at: new Date(),
// // // // // // //     //             id: new Date().getTime() + new Date().getMilliseconds()
// // // // // // //     //         });

// // // // // // //     //         setShowModal(false);
// // // // // // //     //         alert("File uploaded successfully!");
// // // // // // //     //     } catch (error) {
// // // // // // //     //         console.error("Error uploading file:", error);
// // // // // // //     //         alert("Error uploading file");
// // // // // // //     //     }
// // // // // // //     // };


// // // // // // //     // Handle Upload Submission
// // // // // // //     const handleUploadSubmit = async () => {
// // // // // // //         if (!uploadData.url) {
// // // // // // //             alert("Please enter a valid URL");
// // // // // // //             return;
// // // // // // //         }

// // // // // // //         try {
// // // // // // //             await addDoc(collection(db, "nv_downloads"), {
// // // // // // //                 category: "Design",
// // // // // // //                 created_date: new Date(),
// // // // // // //                 date: new Date(),
// // // // // // //                 image: "",
// // // // // // //                 phone_no: uploadData.phoneNo,
// // // // // // //                 selected: false,
// // // // // // //                 title: uploadData.itemName,
// // // // // // //                 url: uploadData.url // Store URL as an array
// // // // // // //             });


// // // // // // //             // 1️⃣ Fetch username from personal_details where phone_no = uploadData.phoneNo
// // // // // // //             const querySnapshot = await getDocs(
// // // // // // //                 query(collection(db, "personal_details"), where("phone_no", "==", uploadData.phoneNo))
// // // // // // //             );

// // // // // // //             if (querySnapshot.empty) {
// // // // // // //                 alert("User not found!");
// // // // // // //                 return;
// // // // // // //             }

// // // // // // //             let username = "";
// // // // // // //             querySnapshot.forEach((doc) => {
// // // // // // //                 username = doc.data().username; // Get username
// // // // // // //             });

// // // // // // //             // 2️⃣ Now create entry in nv_notifications
// // // // // // //             await addDoc(collection(db, "nv_notifications"), {
// // // // // // //                 actions: false,
// // // // // // //                 category: "Design",
// // // // // // //                 created_at: new Date(),
// // // // // // //                 image: "",
// // // // // // //                 is_download: "",
// // // // // // //                 is_join: "",
// // // // // // //                 redirect_page: "",
// // // // // // //                 requested_phone_no: uploadData.phoneNo,
// // // // // // //                 requested_user: username,
// // // // // // //                 seen_by: [],
// // // // // // //                 status: "1",
// // // // // // //                 timestamp: new Date(),
// // // // // // //                 title: `Your ${uploadData.itemName} is ready to download`,
// // // // // // //                 type: "",
// // // // // // //                 user_id: username, // ✅ Use username as user_id
// // // // // // //                 id: new Date().getTime() + new Date().getMilliseconds()
// // // // // // //             });

// // // // // // //             setShowModal(false);
// // // // // // //             alert("File uploaded successfully!");
// // // // // // //         } catch (error) {
// // // // // // //             console.error("Error uploading file:", error);
// // // // // // //             alert("Error uploading file");
// // // // // // //         }
// // // // // // //     };


// // // // // // //     return (
// // // // // // //         <>
// // // // // // //             <div className="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
// // // // // // //                 <Link to="/">
// // // // // // //                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
// // // // // // //                 </Link>
// // // // // // //             </div>

// // // // // // //             {/* Search and Excel Export Buttons */}
// // // // // // //             <div className="d-flex justify-content-between mb-3">


// // // // // // //             </div>
// // // // // // //             <div className="p-3">
// // // // // // //                 <div className="mb-3 d-flex align-items-center gap-3">
// // // // // // //                     <div>
// // // // // // //                         <Button variant="success" onClick={exportToExcel}>
// // // // // // //                             Download Excel
// // // // // // //                         </Button>
// // // // // // //                     </div>

// // // // // // //                     <Form.Control
// // // // // // //                         type="text"
// // // // // // //                         placeholder="Search by Phone Number..."
// // // // // // //                         value={searchQuery}
// // // // // // //                         onChange={handleSearch}
// // // // // // //                         style={{ width: "300px" }}
// // // // // // //                     />
// // // // // // //                 </div>
// // // // // // //                 <div className="card-header pb-0 px-3">
// // // // // // //                     <h4 className="mb-2">Orders List</h4>
// // // // // // //                 </div>
// // // // // // //                 <div className="table-responsive fix-width scroll-inner">
// // // // // // //                     <table className="table table-bordered table-hover">
// // // // // // //                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// // // // // // //                             <tr>
// // // // // // //                                 <th>Order ID</th>
// // // // // // //                                 <th>Full Name</th>
// // // // // // //                                 <th>Business Name</th>
// // // // // // //                                 <th>Item Name</th>
// // // // // // //                                 <th>Item Price</th>
// // // // // // //                                 <th>Order Date</th>
// // // // // // //                                 <th>Process Steps</th>
// // // // // // //                             </tr>
// // // // // // //                         </thead>
// // // // // // //                         <tbody>
// // // // // // //                             {filteredOrders.map((order) =>
// // // // // // //                                 order.items.map((item, itemIndex) => (
// // // // // // //                                     <tr key={`${order.id}-${itemIndex}`} style={{ background: order.status === "Completed" ? "palegreen" : "" }}>
// // // // // // //                                         <td>{order.id || "N/A"} <p>Total Amount : {order.final_total || "N/A"}</p></td>

// // // // // // //                                         <td>{order.full_name || "N/A"} <p>{order.phone_no || "N/A"}</p></td>
// // // // // // //                                         <td>{order.business_name}</td>
// // // // // // //                                         <td>{item.name}</td>
// // // // // // //                                         <td>{item.membership_price}</td>
// // // // // // //                                         <td>{Moment(order.order_date).format("YYYY-MM-DD HH:mm")}</td>
// // // // // // //                                         <td>
// // // // // // //                                             {/* <Accordion>
// // // // // // //                                                 <Accordion.Item eventKey="0">
// // // // // // //                                                     <Accordion.Header>View Steps</Accordion.Header>
// // // // // // //                                                     <Accordion.Body>
// // // // // // //                                                         {item.process.map((step, processIndex) => (
// // // // // // //                                                             <div key={`${order.id}-${itemIndex}-${processIndex}`} className="d-flex align-items-center justify-content-between mb-2">
// // // // // // //                                                                 <strong>{step.step}:</strong>
// // // // // // //                                                                 <div>

// // // // // // //                                                                     {step.step === "Delivery" && (
// // // // // // //                                                                         <Button
// // // // // // //                                                                             variant="primary"
// // // // // // //                                                                             size="sm"
// // // // // // //                                                                             className="ms-2"
// // // // // // //                                                                             onClick={() => openUploadModal(order.id, order.phone_no, item.name)}
// // // // // // //                                                                             disabled={step.status === "completed"} // ✅ Disable if order is completed
// // // // // // //                                                                         >
// // // // // // //                                                                             Upload File
// // // // // // //                                                                         </Button>
// // // // // // //                                                                     )}
// // // // // // //                                                                     <p></p>
// // // // // // //                                                                     <Button
// // // // // // //                                                                         variant={step.status === "completed" ? "success" : "danger"}
// // // // // // //                                                                         size="sm"
// // // // // // //                                                                         onClick={() =>
// // // // // // //                                                                             handleStatusChange(
// // // // // // //                                                                                 order.id,
// // // // // // //                                                                                 itemIndex,
// // // // // // //                                                                                 processIndex,
// // // // // // //                                                                                 step.status === "pending" ? "completed" : "pending"
// // // // // // //                                                                             )
// // // // // // //                                                                         }
// // // // // // //                                                                         disabled={step.status === "completed"} // ✅ Disable if order is completed
// // // // // // //                                                                     >
// // // // // // //                                                                         {step.status === "pending" ? "Mark Completed" : "Mark Pending"}
// // // // // // //                                                                     </Button>
// // // // // // //                                                                 </div>
// // // // // // //                                                             </div>
// // // // // // //                                                         ))}
// // // // // // //                                                     </Accordion.Body>
// // // // // // //                                                 </Accordion.Item>
// // // // // // //                                             </Accordion> */}

// // // // // // //                                             <Accordion>
// // // // // // //                                                 <Accordion.Item eventKey="0">
// // // // // // //                                                     <Accordion.Header>View Steps</Accordion.Header>
// // // // // // //                                                     <Accordion.Body>
// // // // // // //                                                         {item.process.map((step, processIndex) => (
// // // // // // //                                                             <div key={`${order.id}-${itemIndex}-${processIndex}`} className="d-flex align-items-center justify-content-between mb-2">
// // // // // // //                                                                 <strong>{step.step}:</strong>
// // // // // // //                                                                 <div>
// // // // // // //                                                                     <Button
// // // // // // //                                                                         variant={step.status === "completed" ? "success" : "danger"}
// // // // // // //                                                                         size="sm"
// // // // // // //                                                                         onClick={() =>
// // // // // // //                                                                             handleStatusChange(
// // // // // // //                                                                                 order.id,
// // // // // // //                                                                                 itemIndex,
// // // // // // //                                                                                 processIndex,
// // // // // // //                                                                                 step.status === "pending" ? "completed" : "pending"
// // // // // // //                                                                             )
// // // // // // //                                                                         }
// // // // // // //                                                                     >
// // // // // // //                                                                         {step.status === "pending" ? "Mark Completed" : "Mark Pending"}
// // // // // // //                                                                     </Button>

// // // // // // //                                                                     {/* Show Upload Button Before "Delivery" Step */}
// // // // // // //                                                                     {step.step === "Delivery" && (
// // // // // // //                                                                         <Button
// // // // // // //                                                                             variant="primary"
// // // // // // //                                                                             size="sm"
// // // // // // //                                                                             className="ms-2"
// // // // // // //                                                                             onClick={() =>
// // // // // // //                                                                                 openUploadModal(order.id, order.phone_no, item.name)
// // // // // // //                                                                             }
// // // // // // //                                                                         >
// // // // // // //                                                                             Upload File
// // // // // // //                                                                         </Button>
// // // // // // //                                                                     )}
// // // // // // //                                                                 </div>
// // // // // // //                                                             </div>
// // // // // // //                                                         ))}
// // // // // // //                                                     </Accordion.Body>
// // // // // // //                                                 </Accordion.Item>
// // // // // // //                                             </Accordion>
// // // // // // //                                         </td>

// // // // // // //                                     </tr>
// // // // // // //                                 ))
// // // // // // //                             )}
// // // // // // //                         </tbody>
// // // // // // //                     </table>
// // // // // // //                 </div>

// // // // // // //                 {/* Upload File Modal */}
// // // // // // //                 <Modal show={showModal} onHide={() => setShowModal(false)}>
// // // // // // //                     <Modal.Header closeButton>
// // // // // // //                         <Modal.Title>Upload File URL</Modal.Title>
// // // // // // //                     </Modal.Header>
// // // // // // //                     <Modal.Body>
// // // // // // //                         <Form.Group className="mb-3">
// // // // // // //                             <Form.Label>File URL</Form.Label>
// // // // // // //                             <Form.Control
// // // // // // //                                 type="text"
// // // // // // //                                 placeholder="Enter file URL"
// // // // // // //                                 value={uploadData.url}
// // // // // // //                                 onChange={(e) => setUploadData({ ...uploadData, url: e.target.value })}
// // // // // // //                             />
// // // // // // //                         </Form.Group>
// // // // // // //                     </Modal.Body>
// // // // // // //                     <Modal.Footer>
// // // // // // //                         <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
// // // // // // //                         <Button variant="primary" onClick={handleUploadSubmit}>Submit</Button>
// // // // // // //                     </Modal.Footer>
// // // // // // //                 </Modal>
// // // // // // //             </div>
// // // // // // //         </>
// // // // // // //     );
// // // // // // // };

// // // // // // // export default OrdersData;



// // // // // // // // import React, { useState, useEffect } from "react";


// // // // // // // // import { useNavigate, Link, useParams } from 'react-router-dom';
// // // // // // // // import Swal from 'sweetalert2'
// // // // // // // // import db from "./Firebase";
// // // // // // // // import { storage } from './Firebase';
// // // // // // // // import { collection, doc, getDoc, updateDoc, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";
// // // // // // // // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // // // // // // // import Moment from 'moment';
// // // // // // // // import { extendMoment } from 'moment-range';

// // // // // // // // import { Accordion, Button, Table, Container } from "react-bootstrap";

// // // // // // // // const OrdersData = () => {
// // // // // // // //     const [orders, setOrders] = useState([]);

// // // // // // // //     useEffect(() => {
// // // // // // // //         fetchOrders();
// // // // // // // //     }, []);

// // // // // // // //     // Fetch all orders from Firestore
// // // // // // // //     const fetchOrders = async () => {
// // // // // // // //         const ordersRef = collection(db, "nv_orders_data");
// // // // // // // //         const querySnapshot = await getDocs(ordersRef);

// // // // // // // //         const ordersData = [];
// // // // // // // //         querySnapshot.forEach((docSnap) => {
// // // // // // // //             ordersData.push({
// // // // // // // //                 id: docSnap.id,
// // // // // // // //                 ...docSnap.data(),
// // // // // // // //             });
// // // // // // // //         });

// // // // // // // //         setOrders(ordersData);
// // // // // // // //     };

// // // // // // // //     // // Update process status in Firestore
// // // // // // // //     // const handleStatusChange = async (orderId, itemIndex, processIndex, newStatus) => {
// // // // // // // //     //     const orderRef = doc(db, "nv_orders_data", orderId);
// // // // // // // //     //     const orderSnap = await getDoc(orderRef);

// // // // // // // //     //     if (orderSnap.exists()) {
// // // // // // // //     //         let updatedOrder = orderSnap.data();
// // // // // // // //     //         updatedOrder.items[itemIndex].process[processIndex].status = newStatus;

// // // // // // // //     //         await updateDoc(orderRef, { items: updatedOrder.items });

// // // // // // // //     //         setOrders((prevOrders) =>
// // // // // // // //     //             prevOrders.map((order) =>
// // // // // // // //     //                 order.id === orderId ? { ...order, items: updatedOrder.items } : order
// // // // // // // //     //             )
// // // // // // // //     //         );
// // // // // // // //     //     }
// // // // // // // //     // };

// // // // // // // //     const handleStatusChange = async (orderId, itemIndex, processIndex, newStatus) => {
// // // // // // // //         const orderRef = doc(db, "nv_orders_data", orderId);
// // // // // // // //         const orderSnap = await getDoc(orderRef);

// // // // // // // //         if (orderSnap.exists()) {
// // // // // // // //             let updatedOrder = orderSnap.data();

// // // // // // // //             // Update status & isActive
// // // // // // // //             updatedOrder.items[itemIndex].process[processIndex].status = newStatus;
// // // // // // // //             updatedOrder.items[itemIndex].process[processIndex].isActive = newStatus === "completed";

// // // // // // // //             // Update Firestore
// // // // // // // //             await updateDoc(orderRef, { items: updatedOrder.items });

// // // // // // // //             // Update UI state
// // // // // // // //             setOrders((prevOrders) =>
// // // // // // // //                 prevOrders.map((order) =>
// // // // // // // //                     order.id === orderId ? { ...order, items: updatedOrder.items } : order
// // // // // // // //                 )
// // // // // // // //             );
// // // // // // // //         }
// // // // // // // //     };


// // // // // // // //     return (
// // // // // // // //         <Container className="mt-4">
// // // // // // // //             <h2 className="text-center mb-4">Orders List</h2>
// // // // // // // //             <Table striped bordered hover responsive>
// // // // // // // //                 <thead className="table-dark">
// // // // // // // //                     <tr>
// // // // // // // //                         <th>Order ID</th>
// // // // // // // //                         <th>Full Name</th>
// // // // // // // //                         <th>Phone No</th>
// // // // // // // //                         <th>Business Name</th>
// // // // // // // //                         <th>Item Name</th>
// // // // // // // //                         <th>Item Price</th>
// // // // // // // //                         <th>Order Date</th>
// // // // // // // //                         <th>Process Steps</th>
// // // // // // // //                     </tr>
// // // // // // // //                 </thead>
// // // // // // // //                 <tbody>
// // // // // // // //                     {orders.map((order) =>
// // // // // // // //                         order.items.map((item, itemIndex) => (
// // // // // // // //                             <tr key={`${order.id}-${itemIndex}`}>
// // // // // // // //                                 <td>{order.id}</td>
// // // // // // // //                                 <td>{order.full_name}</td>
// // // // // // // //                                 <td>{order.phone_no}</td>
// // // // // // // //                                 <td>{order.business_name}</td>
// // // // // // // //                                 <td>{item.name}</td>
// // // // // // // //                                 <td>${item.membership_price}</td>
// // // // // // // //                                 <td>{Moment(order.order_date).format("YYYY-MM-DD HH:mm")}</td>
// // // // // // // //                                 <td>
// // // // // // // //                                     <Accordion>
// // // // // // // //                                         <Accordion.Item eventKey="0">
// // // // // // // //                                             <Accordion.Header>View Steps</Accordion.Header>
// // // // // // // //                                             <Accordion.Body>
// // // // // // // //                                                 {item.process.map((step, processIndex) => (
// // // // // // // //                                                     <div key={`${order.id}-${itemIndex}-${processIndex}`} className="d-flex align-items-center justify-content-between mb-2">
// // // // // // // //                                                         <strong>{step.step}:</strong>
// // // // // // // //                                                         <Button
// // // // // // // //                                                             variant={step.status === "completed" ? "success" : "danger"}
// // // // // // // //                                                             size="sm"
// // // // // // // //                                                             onClick={() =>
// // // // // // // //                                                                 handleStatusChange(
// // // // // // // //                                                                     order.id,
// // // // // // // //                                                                     itemIndex,
// // // // // // // //                                                                     processIndex,
// // // // // // // //                                                                     step.status === "pending" ? "completed" : "pending"
// // // // // // // //                                                                 )
// // // // // // // //                                                             }
// // // // // // // //                                                         >
// // // // // // // //                                                             {step.status === "pending" ? "Mark Completed" : "Mark Pending"}
// // // // // // // //                                                         </Button>
// // // // // // // //                                                     </div>
// // // // // // // //                                                 ))}
// // // // // // // //                                             </Accordion.Body>
// // // // // // // //                                         </Accordion.Item>
// // // // // // // //                                     </Accordion>
// // // // // // // //                                 </td>
// // // // // // // //                             </tr>
// // // // // // // //                         ))
// // // // // // // //                     )}
// // // // // // // //                 </tbody>
// // // // // // // //             </Table>
// // // // // // // //         </Container>
// // // // // // // //     );
// // // // // // // // };

// // // // // // // // export default OrdersData;




// // // // // // // // // import React, { useState, useEffect } from "react";


// // // // // // // // // import { useNavigate, Link, useParams } from 'react-router-dom';
// // // // // // // // // import Swal from 'sweetalert2'
// // // // // // // // // import db from "./Firebase";
// // // // // // // // // import { storage } from './Firebase';
// // // // // // // // // import { collection, doc, getDoc, updateDoc, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";
// // // // // // // // // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // // // // // // // // import Moment from 'moment';
// // // // // // // // // import { extendMoment } from 'moment-range';

// // // // // // // // // const OrdersData = () => {
// // // // // // // // //     const [orders, setOrders] = useState([]);

// // // // // // // // //     useEffect(() => {
// // // // // // // // //         fetchOrders();
// // // // // // // // //     }, []);

// // // // // // // // //     // Fetch all order data from Firestore
// // // // // // // // //     const fetchOrders = async () => {
// // // // // // // // //         const ordersRef = collection(db, "nv_orders_data");
// // // // // // // // //         const querySnapshot = await getDocs(ordersRef);

// // // // // // // // //         const ordersData = [];
// // // // // // // // //         querySnapshot.forEach((docSnap) => {
// // // // // // // // //             ordersData.push({
// // // // // // // // //                 id: docSnap.id,  // Save document ID
// // // // // // // // //                 ...docSnap.data(),  // Merge order data
// // // // // // // // //             });
// // // // // // // // //         });

// // // // // // // // //         setOrders(ordersData);
// // // // // // // // //     };

// // // // // // // // //     // Update process status in Firebase for the specific item
// // // // // // // // //     const handleStatusChange = async (orderId, itemIndex, processIndex, newStatus) => {
// // // // // // // // //         const orderRef = doc(db, "nv_orders_data", orderId);
// // // // // // // // //         const orderSnap = await getDoc(orderRef);

// // // // // // // // //         if (orderSnap.exists()) {
// // // // // // // // //             let updatedOrder = orderSnap.data();
// // // // // // // // //             updatedOrder.items[itemIndex].process[processIndex].status = newStatus;

// // // // // // // // //             await updateDoc(orderRef, { items: updatedOrder.items });
// // // // // // // // //             setOrders((prevOrders) =>
// // // // // // // // //                 prevOrders.map((order) =>
// // // // // // // // //                     order.id === orderId
// // // // // // // // //                         ? { ...order, items: updatedOrder.items }
// // // // // // // // //                         : order
// // // // // // // // //                 )
// // // // // // // // //             );
// // // // // // // // //         }
// // // // // // // // //     };

// // // // // // // // //     return (
// // // // // // // // //         <div>
// // // // // // // // //             <h2>Orders</h2>
// // // // // // // // //             <table border="1">
// // // // // // // // //                 <thead>
// // // // // // // // //                     <tr>
// // // // // // // // //                         <th>Order ID</th>
// // // // // // // // //                         <th>Full Name</th>
// // // // // // // // //                         <th>Phone No</th>
// // // // // // // // //                         <th>Business Name</th>
// // // // // // // // //                         <th>Item Name</th>
// // // // // // // // //                         <th>Item Price</th>
// // // // // // // // //                         <th>Item Status</th>
// // // // // // // // //                         <th>Order Date</th>
// // // // // // // // //                         <th>Process Step</th>
// // // // // // // // //                         <th>Change Status</th>
// // // // // // // // //                     </tr>
// // // // // // // // //                 </thead>
// // // // // // // // //                 <tbody>
// // // // // // // // //                     {orders.map((order) =>
// // // // // // // // //                         order.items.map((item, itemIndex) =>
// // // // // // // // //                             item.process.map((step, processIndex) => (
// // // // // // // // //                                 <tr key={`${order.id}-${itemIndex}-${processIndex}`}>
// // // // // // // // //                                     <td>{order.id}</td>
// // // // // // // // //                                     <td>{order.full_name}</td>
// // // // // // // // //                                     <td>{order.phone_no}</td>
// // // // // // // // //                                     <td>{order.business_name}</td>
// // // // // // // // //                                     <td>{item.name}</td>
// // // // // // // // //                                     <td>${item.membership_price}</td>
// // // // // // // // //                                     <td>{order.status}</td>
// // // // // // // // //                                     <td>{Moment(order.order_date).format("YYYY-MM-DD HH:mm")}</td>
// // // // // // // // //                                     <td>{step.step} ({step.status})</td>
// // // // // // // // //                                     <td>
// // // // // // // // //                                         <button
// // // // // // // // //                                             onClick={() => handleStatusChange(
// // // // // // // // //                                                 order.id,
// // // // // // // // //                                                 itemIndex,
// // // // // // // // //                                                 processIndex,
// // // // // // // // //                                                 step.status === "pending" ? "completed" : "pending"
// // // // // // // // //                                             )}
// // // // // // // // //                                             style={{
// // // // // // // // //                                                 backgroundColor: step.status === "completed" ? "green" : "red",
// // // // // // // // //                                                 color: "white",
// // // // // // // // //                                                 border: "none",
// // // // // // // // //                                                 padding: "5px 10px",
// // // // // // // // //                                                 cursor: "pointer"
// // // // // // // // //                                             }}
// // // // // // // // //                                         >
// // // // // // // // //                                             {step.status === "pending" ? "Mark as Completed" : "Mark as Pending"}
// // // // // // // // //                                         </button>
// // // // // // // // //                                     </td>
// // // // // // // // //                                 </tr>
// // // // // // // // //                             ))
// // // // // // // // //                         )
// // // // // // // // //                     )}
// // // // // // // // //                 </tbody>
// // // // // // // // //             </table>
// // // // // // // // //         </div>
// // // // // // // // //     );
// // // // // // // // // };

// // // // // // // // // export default OrdersData;




// // // // // // // // // // import React, { useState, useEffect } from "react";


// // // // // // // // // // import { useNavigate, Link, useParams } from 'react-router-dom';
// // // // // // // // // // import Swal from 'sweetalert2'
// // // // // // // // // // import db from "./Firebase";
// // // // // // // // // // import { storage } from './Firebase';
// // // // // // // // // // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // // // // // // // // // import Moment from 'moment';
// // // // // // // // // // import { extendMoment } from 'moment-range';

// // // // // // // // // // function OrdersData() {

// // // // // // // // // //     const moment = extendMoment(Moment);
// // // // // // // // // //     const [data, setData] = useState([]);
// // // // // // // // // //     const [searchQuery, setSearchQuery] = useState("");
// // // // // // // // // //     const [modalData, setModalData] = useState(null);
// // // // // // // // // //     // const [modalData, setModalData] = useState({
// // // // // // // // // //     //     category: "Designs",
// // // // // // // // // //     //     image: "https://static.vecteezy.com/system/resources/thumbnails/006/425/314/small_2x/modern-university-certificate-template-free-vector.jpg",
// // // // // // // // // //     //     phone_no: "",
// // // // // // // // // //     //     selected: false,
// // // // // // // // // //     //     title: "First Step Bundle",
// // // // // // // // // //     //     urls: [""], // Store multiple URLs
// // // // // // // // // //     // });
// // // // // // // // // //     const [showModal, setShowModal] = useState(false);


// // // // // // // // // //     const handleUrlChange = (index, value) => {
// // // // // // // // // //         const updatedUrls = [...modalData.urls];
// // // // // // // // // //         updatedUrls[index] = value;
// // // // // // // // // //         setModalData({ ...modalData, urls: updatedUrls });
// // // // // // // // // //     };


// // // // // // // // // //     const addUrlField = () => {
// // // // // // // // // //         setModalData({ ...modalData, urls: [...modalData.urls, ""] });
// // // // // // // // // //     };

// // // // // // // // // //     const removeUrlField = (index) => {
// // // // // // // // // //         const updatedUrls = modalData.urls.filter((_, i) => i !== index);
// // // // // // // // // //         setModalData({ ...modalData, urls: updatedUrls });
// // // // // // // // // //     };


// // // // // // // // // //     useEffect(() => {
// // // // // // // // // //         db.collection("nv_orders_data").orderBy("order_date", "desc").onSnapshot((snapshot) => {
// // // // // // // // // //             setData(
// // // // // // // // // //                 snapshot.docs.map((doc) => ({
// // // // // // // // // //                     id: doc.id,
// // // // // // // // // //                     data: doc.data(),
// // // // // // // // // //                 }))
// // // // // // // // // //             );
// // // // // // // // // //         });

// // // // // // // // // //     }, []);

// // // // // // // // // //     // Step 3: Filter data based on search query and availability filter
// // // // // // // // // //     // const filteredData = data.filter((record) => {
// // // // // // // // // //     //     return (
// // // // // // // // // //     //         record.data.phone_no.includes(searchQuery)
// // // // // // // // // //     //     );
// // // // // // // // // //     // });

// // // // // // // // // //     const filteredData = data.filter((record) => record.data.phone_no.includes(searchQuery));


// // // // // // // // // //     const handleSearch = (e) => {
// // // // // // // // // //         setSearchQuery(e.target.value); // Step 3: Update search query state
// // // // // // // // // //     }



// // // // // // // // // //     // const openModal = (record) => {
// // // // // // // // // //     //     setModalData({
// // // // // // // // // //     //         category: "Designs",
// // // // // // // // // //     //         image: "https://static.vecteezy.com/system/resources/thumbnails/006/425/314/small_2x/modern-university-certificate-template-free-vector.jpg",
// // // // // // // // // //     //         phone_no: record.data.phone_no,
// // // // // // // // // //     //         selected: false,
// // // // // // // // // //     //         title: "First Step Bundle",
// // // // // // // // // //     //         url: "", // User will enter manually
// // // // // // // // // //     //     });
// // // // // // // // // //     //     setShowModal(true);
// // // // // // // // // //     // };

// // // // // // // // // //     const openModal = (record) => {
// // // // // // // // // //         setModalData({
// // // // // // // // // //             category: "Designs",
// // // // // // // // // //             image: "https://static.vecteezy.com/system/resources/thumbnails/006/425/314/small_2x/modern-university-certificate-template-free-vector.jpg",
// // // // // // // // // //             phone_no: record.data.phone_no,
// // // // // // // // // //             selected: false,
// // // // // // // // // //             title: "First Step Bundle",
// // // // // // // // // //             urls: [""], // ✅ Correct: Use an array
// // // // // // // // // //         });
// // // // // // // // // //         setShowModal(true);
// // // // // // // // // //     };




// // // // // // // // // //     const handleChange = (e) => {
// // // // // // // // // //         setModalData({ ...modalData, [e.target.name]: e.target.value });
// // // // // // // // // //     };


// // // // // // // // // //     // const handleSubmit = async () => {
// // // // // // // // // //     //     if (!modalData.url.trim()) {
// // // // // // // // // //     //         Swal.fire("Error", "Please enter a valid URL.", "error");
// // // // // // // // // //     //         return;
// // // // // // // // // //     //     }

// // // // // // // // // //     //     const updatedModalData = {
// // // // // // // // // //     //         ...modalData,
// // // // // // // // // //     //         created_date: new Date(), // Adding created_date before submission
// // // // // // // // // //     //         date: new Date(), // Adding created_date before submission
// // // // // // // // // //     //     };

// // // // // // // // // //     //     try {
// // // // // // // // // //     //         await db.collection("nv_downloads").add(updatedModalData);
// // // // // // // // // //     //         Swal.fire("Success", "Design submitted successfully!", "success");
// // // // // // // // // //     //         setShowModal(false);
// // // // // // // // // //     //     } catch (error) {
// // // // // // // // // //     //         Swal.fire("Error", "Failed to submit design", "error");
// // // // // // // // // //     //     }
// // // // // // // // // //     // };


// // // // // // // // // //     const handleSubmit = async () => {
// // // // // // // // // //         if (modalData.urls.some(url => url.trim() === "")) {
// // // // // // // // // //             Swal.fire("Error", "Please enter a valid URL in all fields.", "error");
// // // // // // // // // //             return;
// // // // // // // // // //         }

// // // // // // // // // //         const submissions = modalData.urls.map(url => ({
// // // // // // // // // //             ...modalData,
// // // // // // // // // //             url, // Different URL for each entry

// // // // // // // // // //             created_date: new Date(),
// // // // // // // // // //             date: new Date(),
// // // // // // // // // //         }));

// // // // // // // // // //         try {
// // // // // // // // // //             const dbPromises = submissions.map(sub => db.collection("nv_downloads").add(sub));
// // // // // // // // // //             await Promise.all(dbPromises);
// // // // // // // // // //             Swal.fire("Success", "Design submitted successfully!", "success");
// // // // // // // // // //             setShowModal(false);
// // // // // // // // // //         } catch (error) {
// // // // // // // // // //             Swal.fire("Error", "Failed to submit design", "error");
// // // // // // // // // //         }
// // // // // // // // // //     };

// // // // // // // // // //     return (
// // // // // // // // // //         <>
// // // // // // // // // //             <div class="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
// // // // // // // // // //                 {/* <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Download Excel</span> */}
// // // // // // // // // //                 <Link to="/"><img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} /></Link>

// // // // // // // // // //             </div>

// // // // // // // // // //             <div class="card-header pb-0 px-3">
// // // // // // // // // //                 <h6 class="mb-2">Orders Tracking Page - (Count : {data.length})</h6>
// // // // // // // // // //             </div>
// // // // // // // // // //             <input
// // // // // // // // // //                 type="text"
// // // // // // // // // //                 className="form-control form-control-sm mb-2"
// // // // // // // // // //                 placeholder="Search by phone no..."
// // // // // // // // // //                 value={searchQuery}
// // // // // // // // // //                 onChange={handleSearch}
// // // // // // // // // //             />




// // // // // // // // // //             <div className="table-responsive fix-width scroll-inner">
// // // // // // // // // //                 <table className="table table-bordered table-hover">
// // // // // // // // // //                     <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// // // // // // // // // //                         <tr>
// // // // // // // // // //                             <th>Sr. No</th>
// // // // // // // // // //                             <th>Order ID</th>
// // // // // // // // // //                             <th>Name</th>
// // // // // // // // // //                             <th>Business</th>
// // // // // // // // // //                             <th>Total (₹)</th>
// // // // // // // // // //                             <th>Order Date</th>
// // // // // // // // // //                             <th>Items</th>
// // // // // // // // // //                             <th>Order Status</th>
// // // // // // // // // //                             <th>Submit Design</th>
// // // // // // // // // //                         </tr>
// // // // // // // // // //                     </thead>
// // // // // // // // // //                     <tbody>
// // // // // // // // // //                         {filteredData?.length > 0 ? (
// // // // // // // // // //                             filteredData.map(({ id, data }, index) => (
// // // // // // // // // //                                 <tr key={id}>
// // // // // // // // // //                                     <td>{index + 1}</td>
// // // // // // // // // //                                     <td>{data.order_id || "N/A"}</td>
// // // // // // // // // //                                     <td>{data.full_name || "N/A"} <p>{data.phone_no || "N/A"}</p></td>
// // // // // // // // // //                                     <td>{data.business_name || "N/A"}</td>
// // // // // // // // // //                                     <td>₹{data.final_total || 0}</td>
// // // // // // // // // //                                     <td>{moment(data.order_date.toDate().toISOString()).format("DD/MM/YY, h:mm a")}</td>
// // // // // // // // // //                                     <td>
// // // // // // // // // //                                         {data.items?.length > 0 ? (
// // // // // // // // // //                                             <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
// // // // // // // // // //                                                 {data.items.map((item, i) => (
// // // // // // // // // //                                                     <li key={i}>
// // // // // // // // // //                                                         <img
// // // // // // // // // //                                                             src={item.image_url || "/images/placeholder.png"}
// // // // // // // // // //                                                             alt={item.name || "Item"}
// // // // // // // // // //                                                             style={{ width: "150px", height: "75px", marginRight: "5px" }}
// // // // // // // // // //                                                         />
// // // // // // // // // //                                                         {item.name || "N/A"} (₹{item.original_price || 0})
// // // // // // // // // //                                                     </li>
// // // // // // // // // //                                                 ))}
// // // // // // // // // //                                             </ul>
// // // // // // // // // //                                         ) : (
// // // // // // // // // //                                             "No items"
// // // // // // // // // //                                         )}
// // // // // // // // // //                                     </td>
// // // // // // // // // //                                     <td>
// // // // // // // // // //                                         <span className={`badge badge-${data.status === "Processing" ? "warning" : "success"}`}>
// // // // // // // // // //                                             {data.status || "N/A"}
// // // // // // // // // //                                         </span>
// // // // // // // // // //                                     </td>
// // // // // // // // // //                                     <td>
// // // // // // // // // //                                         <button className="btn btn-primary btn-sm" onClick={() => openModal({ id, data })}>Submit</button>
// // // // // // // // // //                                     </td>
// // // // // // // // // //                                 </tr>
// // // // // // // // // //                             ))
// // // // // // // // // //                         ) : (
// // // // // // // // // //                             <tr>
// // // // // // // // // //                                 <td colSpan="9" className="text-center">No orders found</td>
// // // // // // // // // //                             </tr>
// // // // // // // // // //                         )}
// // // // // // // // // //                     </tbody>
// // // // // // // // // //                 </table>
// // // // // // // // // //             </div>

// // // // // // // // // //             {showModal && modalData && (
// // // // // // // // // //                 <div className="modal show" style={{ display: "block" }}>
// // // // // // // // // //                     <div className="modal-dialog">
// // // // // // // // // //                         <div className="modal-content">
// // // // // // // // // //                             <div className="modal-header">
// // // // // // // // // //                                 <h5 className="modal-title">Submit Design</h5>
// // // // // // // // // //                                 <button type="button" className="close" onClick={() => setShowModal(false)}>&times;</button>
// // // // // // // // // //                             </div>
// // // // // // // // // //                             <div className="modal-body">
// // // // // // // // // //                                 <h6><label><strong>Category : </strong></label> {modalData.category}</h6>

// // // // // // // // // //                                 <h6><label><strong>Phone No : </strong></label> {modalData.phone_no}</h6>

// // // // // // // // // //                                 <h6> <label><strong>Title : </strong></label> {modalData.title}</h6>

// // // // // // // // // //                                 <label><strong>Enter URLs:</strong></label>
// // // // // // // // // //                                 {modalData.urls.map((url, index) => (
// // // // // // // // // //                                     <div key={index} className="d-flex mb-2">
// // // // // // // // // //                                         <input
// // // // // // // // // //                                             type="text"
// // // // // // // // // //                                             name="url"
// // // // // // // // // //                                             value={url}
// // // // // // // // // //                                             onChange={(e) => handleUrlChange(index, e.target.value)}
// // // // // // // // // //                                             className="form-control"
// // // // // // // // // //                                             placeholder="Enter PDF URL"
// // // // // // // // // //                                         />
// // // // // // // // // //                                         {modalData.urls.length > 1 && (
// // // // // // // // // //                                             <button className="btn btn-danger ml-2" onClick={() => removeUrlField(index)}>X</button>
// // // // // // // // // //                                         )}
// // // // // // // // // //                                     </div>
// // // // // // // // // //                                 ))}
// // // // // // // // // //                                 <button className="btn btn-primary mt-2" onClick={addUrlField}>+ Add More URL</button>
// // // // // // // // // //                             </div>
// // // // // // // // // //                             <div className="modal-footer">
// // // // // // // // // //                                 <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
// // // // // // // // // //                                 <button className="btn btn-success" onClick={handleSubmit}>Submit</button>
// // // // // // // // // //                             </div>
// // // // // // // // // //                         </div>
// // // // // // // // // //                     </div>
// // // // // // // // // //                 </div>
// // // // // // // // // //             )}




// // // // // // // // // //         </>
// // // // // // // // // //     )
// // // // // // // // // // }

// // // // // // // // // // export default OrdersData
















// // // // // // // // // // // import React, { useState, useEffect } from "react";


// // // // // // // // // // // import { useNavigate, Link } from 'react-router-dom';
// // // // // // // // // // // import Swal from 'sweetalert2';
// // // // // // // // // // // import db from "./Firebase";
// // // // // // // // // // // import Moment from 'moment';
// // // // // // // // // // // import { extendMoment } from 'moment-range';

// // // // // // // // // // // function OrdersData() {
// // // // // // // // // // //     const moment = extendMoment(Moment);
// // // // // // // // // // //     const [data, setData] = useState([]);
// // // // // // // // // // //     const [searchQuery, setSearchQuery] = useState("");
// // // // // // // // // // //     const [modalData, setModalData] = useState(null);
// // // // // // // // // // //     const [showModal, setShowModal] = useState(false);

// // // // // // // // // // //     useEffect(() => {
// // // // // // // // // // //         db.collection("nv_orders_data")
// // // // // // // // // // //             .orderBy("order_date", "desc")
// // // // // // // // // // //             .onSnapshot((snapshot) => {
// // // // // // // // // // //                 setData(snapshot.docs.map((doc) => ({
// // // // // // // // // // //                     id: doc.id,
// // // // // // // // // // //                     data: doc.data(),
// // // // // // // // // // //                 })));
// // // // // // // // // // //             });
// // // // // // // // // // //     }, []);

// // // // // // // // // // //     const filteredData = data.filter((record) => record.data.phone_no.includes(searchQuery));

// // // // // // // // // // //     const handleSearch = (e) => {
// // // // // // // // // // //         setSearchQuery(e.target.value);
// // // // // // // // // // //     };

// // // // // // // // // // //     const openModal = (record) => {
// // // // // // // // // // //         setModalData({
// // // // // // // // // // //             category: "Designs",
// // // // // // // // // // //             image: "https://static.vecteezy.com/system/resources/thumbnails/006/425/314/small_2x/modern-university-certificate-template-free-vector.jpg",
// // // // // // // // // // //             phone_no: record.data.phone_no,
// // // // // // // // // // //             selected: false,
// // // // // // // // // // //             title: "First Step Bundle",
// // // // // // // // // // //             url: "", // User will enter manually
// // // // // // // // // // //         });
// // // // // // // // // // //         setShowModal(true);
// // // // // // // // // // //     };

// // // // // // // // // // //     const handleChange = (e) => {
// // // // // // // // // // //         setModalData({ ...modalData, [e.target.name]: e.target.value });
// // // // // // // // // // //     };

// // // // // // // // // // //     const handleSubmit = async () => {
// // // // // // // // // // //         if (!modalData.url.trim()) {
// // // // // // // // // // //             Swal.fire("Error", "Please enter a valid URL.", "error");
// // // // // // // // // // //             return;
// // // // // // // // // // //         }

// // // // // // // // // // //         const updatedModalData = {
// // // // // // // // // // //             ...modalData,
// // // // // // // // // // //             created_date: new Date(), // Adding created_date before submission
// // // // // // // // // // //             date: new Date(), // Adding created_date before submission
// // // // // // // // // // //         };

// // // // // // // // // // //         try {
// // // // // // // // // // //             await db.collection("nv_downloads").add(updatedModalData);
// // // // // // // // // // //             Swal.fire("Success", "Design submitted successfully!", "success");
// // // // // // // // // // //             setShowModal(false);
// // // // // // // // // // //         } catch (error) {
// // // // // // // // // // //             Swal.fire("Error", "Failed to submit design", "error");
// // // // // // // // // // //         }
// // // // // // // // // // //     };


// // // // // // // // // // //     return (
// // // // // // // // // // //         <>
// // // // // // // // // // //             <div className="p-2" style={{ display: "flex", justifyContent: "space-between" }}>
// // // // // // // // // // //                 <Link to="/">
// // // // // // // // // // //                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
// // // // // // // // // // //                 </Link>
// // // // // // // // // // //             </div>

// // // // // // // // // // //             <div className="card-header pb-0 px-3">
// // // // // // // // // // //                 <h6>Orders Tracking Page - (Count: {data.length})</h6>
// // // // // // // // // // //             </div>
// // // // // // // // // // //             <input
// // // // // // // // // // //                 type="text"
// // // // // // // // // // //                 className="form-control form-control-sm mb-2"
// // // // // // // // // // //                 placeholder="Search by phone no..."
// // // // // // // // // // //                 value={searchQuery}
// // // // // // // // // // //                 onChange={handleSearch}
// // // // // // // // // // //             />

// // // // // // // // // // //             <div className="table-responsive fix-width scroll-inner">
// // // // // // // // // // //                 <table className="table table-bordered table-hover">
// // // // // // // // // // //                     <thead className="thead-dark">
// // // // // // // // // // //                         <tr>
// // // // // // // // // // //                             <th>Sr. No</th>
// // // // // // // // // // //                             <th>Order ID</th>
// // // // // // // // // // //                             <th>Name</th>
// // // // // // // // // // //                             <th>Business</th>
// // // // // // // // // // //                             <th>Total (₹)</th>
// // // // // // // // // // //                             <th>Order Date</th>
// // // // // // // // // // //                             <th>Submit Design</th>
// // // // // // // // // // //                         </tr>
// // // // // // // // // // //                     </thead>
// // // // // // // // // // //                     <tbody>
// // // // // // // // // // //                         {filteredData.length > 0 ? (
// // // // // // // // // // //                             filteredData.map(({ id, data }, index) => (
// // // // // // // // // // //                                 <tr key={id}>
// // // // // // // // // // //                                     <td>{index + 1}</td>
// // // // // // // // // // //                                     <td>{data.order_id || "N/A"}</td>
// // // // // // // // // // //                                     <td>{data.full_name || "N/A"} <p>{data.phone_no || "N/A"}</p></td>
// // // // // // // // // // //                                     <td>{data.business_name || "N/A"}</td>
// // // // // // // // // // //                                     <td>₹{data.final_total || 0}</td>
// // // // // // // // // // //                                     <td>{moment(data.order_date.toDate().toISOString()).format("DD/MM/YY, h:mm a")}</td>
// // // // // // // // // // //                                     <td>
// // // // // // // // // // //                                         <button className="btn btn-primary btn-sm" onClick={() => openModal({ id, data })}>Submit</button>
// // // // // // // // // // //                                     </td>
// // // // // // // // // // //                                 </tr>
// // // // // // // // // // //                             ))
// // // // // // // // // // //                         ) : (
// // // // // // // // // // //                             <tr>
// // // // // // // // // // //                                 <td colSpan="7" className="text-center">No orders found</td>
// // // // // // // // // // //                             </tr>
// // // // // // // // // // //                         )}
// // // // // // // // // // //                     </tbody>
// // // // // // // // // // //                 </table>
// // // // // // // // // // //             </div>

// // // // // // // // // // //             {showModal && modalData && (
// // // // // // // // // // //                 <div className="modal show" style={{ display: "block" }}>
// // // // // // // // // // //                     <div className="modal-dialog">
// // // // // // // // // // //                         <div className="modal-content">
// // // // // // // // // // //                             <div className="modal-header">
// // // // // // // // // // //                                 <h5 className="modal-title">Submit Design</h5>
// // // // // // // // // // //                                 <button type="button" className="close" onClick={() => setShowModal(false)}>&times;</button>
// // // // // // // // // // //                             </div>
// // // // // // // // // // //                             <div className="modal-body">
// // // // // // // // // // //                                 <label><strong>Category : </strong></label> {modalData.category}
// // // // // // // // // // //                                 <p></p>
// // // // // // // // // // //                                 <label><strong>Phone No : </strong></label> {modalData.phone_no}
// // // // // // // // // // //                                 <p></p>
// // // // // // // // // // //                                 <label><strong>Title : </strong></label> {modalData.title}
// // // // // // // // // // //                                 <label><strong>Enter URL:</strong></label>
// // // // // // // // // // //                                 <input
// // // // // // // // // // //                                     type="text"
// // // // // // // // // // //                                     name="url"
// // // // // // // // // // //                                     value={modalData.url}
// // // // // // // // // // //                                     onChange={handleChange}
// // // // // // // // // // //                                     className="form-control"
// // // // // // // // // // //                                     placeholder="Enter PDF URL"
// // // // // // // // // // //                                 />
// // // // // // // // // // //                             </div>
// // // // // // // // // // //                             <div className="modal-footer">
// // // // // // // // // // //                                 <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
// // // // // // // // // // //                                 <button className="btn btn-success" onClick={handleSubmit}>Submit</button>
// // // // // // // // // // //                             </div>
// // // // // // // // // // //                         </div>
// // // // // // // // // // //                     </div>
// // // // // // // // // // //                 </div>
// // // // // // // // // // //             )}
// // // // // // // // // // //         </>
// // // // // // // // // // //     );
// // // // // // // // // // // }

// // // // // // // // // // // export default OrdersData;
